import React, { useState, useRef, useEffect, } from 'react';
import { useContext } from 'react';
import { CartContext } from '../../context/CartContext';
import { ServiceContext } from '../../context/ServiceContext';
import { LocationProvider, useLocationContext } from '../../context/LocationContext';
import TyroPayment from '../../components/TyroPayment/TyroPayment';
import LoadingOverlay from '../../components/loadingOverlay/loadingOverlay';
import CrmLegalModal from '../../components/crmLegal/CrmLegalModal';

import axios from 'axios';
import { useParams, useSearchParams } from 'react-router-dom';
import useGetState from '../../hooks/useGetState';
import { useNavigate } from 'react-router-dom';
import './orderDetails.css';
import { Spin, Modal, TimePicker, Input, InputNumber, Button, message } from 'antd'; // 引入 Modal、TimePicker、Input、message
import moment from 'moment'; // 引入 moment
import { isServiceAvailable } from '../../utils/serviceHours';
import { useSharedCart, sharedCartNoticeText } from '../../hooks/useSharedCart';

function OrderDetails() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const timeoutRef = useRef(null);
    const lastActiveTimeRef = useRef(Date.now());
    const SESSION_TIMEOUT = 10 * 60 * 1000; // 10分钟超时时间（毫秒）

    // 创建一个ref来保存handleLoadingComplete回调函数
    const loadingCompleteCallbackRef = useRef(() => {
        setIsLoading(false);
    });

    const { isLocationValid, hasVisitedPayment } = useLocationContext();

    // 页面超时处理函数
    const handleTimeout = () => {
        const currentTime = Date.now();
        const timePassed = currentTime - lastActiveTimeRef.current;
        
        if (timePassed >= SESSION_TIMEOUT) {
            // 超过30分钟，返回主页
            message.info('Session expired. Redirecting to home page.');
            navigate(`/qr_order/${restaurantUrl}/${tableNumber}`);
        } else {
            // 未超时，继续检查
            const remainingTime = SESSION_TIMEOUT - timePassed;
            timeoutRef.current = setTimeout(handleTimeout, Math.min(remainingTime, 60000)); // 最多每分钟检查一次
        }
    };

    // 处理页面可见性变化
    const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            // 页面重新变为可见时，更新最后活动时间并重新启动定时器
            lastActiveTimeRef.current = Date.now();
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(handleTimeout, 60000); // 每分钟检查一次
        }
    };

    // 用户交互时更新最后活动时间
    const updateLastActiveTime = () => {
        lastActiveTimeRef.current = Date.now();
    };

    // 设置超时检查和事件监听
    useEffect(() => {
        // 初始化定时器
        timeoutRef.current = setTimeout(handleTimeout, 60000); // 每分钟检查一次
        
        // 设置页面可见性变化监听
        document.addEventListener('visibilitychange', handleVisibilityChange);
        
        // 设置用户交互监听
        window.addEventListener('click', updateLastActiveTime);
        window.addEventListener('keypress', updateLastActiveTime);
        window.addEventListener('scroll', updateLastActiveTime);
        window.addEventListener('mousemove', updateLastActiveTime);
        
        return () => {
            // 清理定时器和事件监听
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('click', updateLastActiveTime);
            window.removeEventListener('keypress', updateLastActiveTime);
            window.removeEventListener('scroll', updateLastActiveTime);
            window.removeEventListener('mousemove', updateLastActiveTime);
        };
    }, []);

    useEffect(() => {
        if (!isLocationValid && !hasVisitedPayment) {
            navigate('/warning');
        }
    }, [isLocationValid, navigate]);

    const [firstLanguage, setFirstLanguage] = useState(null);
    const [secondLanguage, setSecondLanguage] = useState(null);
    const [styleColor, setStyleColor] = useState("#ffda62");

    const [isOrdering, setIsOrdering] = useState(false);
    const [storeId, setStoreId] = useState(null);
    const [storeAddress, setStoreAddress] = useState(null);
    const [storePhone, setStorePhone] = useState(null);
    const [storeImg, setStoreImg] = useState(null);
    const [storeTimetable, setStoreTimetable, getStoreTimetable] = useGetState(null);
    const [storeHoursConfig, setStoreHoursConfig] = useState(null);
    const [serviceType, setServiceType] = useState(null);

    const [showNoteBox, setShowNoteBox] = useState(false);
    const [note, setNote] = useState('');
    const [surcharges, setSurcharges] = useState([]);
    const [surchargeDescription, setSurchargeDescription] = useState('');

    const [side_popup, setSide_popup] = useState(false);

    // 新增的状态变量
    const [userInfo, setUserInfo] = useState({ name: '', contactNumber: '', address: '' });
    const [isUserInfoModalVisible, setIsUserInfoModalVisible] = useState(false);

    const [scheduleInfo, setScheduleInfo] = useState({ asap: true, time: null });
    const [isScheduleModalVisible, setIsScheduleModalVisible] = useState(false);
    const [needCustomerInfo, setNeedCustomerInfo] = useState(false);
    const [requireDineInGuestCount, setRequireDineInGuestCount] = useState(false);
    const [deliveryEnabled, setDeliveryEnabled] = useState(false);
    const [deliveryMinimumOrderAmount, setDeliveryMinimumOrderAmount] = useState(0);
    const [orderServiceMode, setOrderServiceMode] = useState('');
    const [deliveryQuote, setDeliveryQuote] = useState(null);
    const [deliveryQuoteLoading, setDeliveryQuoteLoading] = useState(false);
    const [deliveryQuoteError, setDeliveryQuoteError] = useState('');
    const [deliveryAddressPlaceId, setDeliveryAddressPlaceId] = useState('');
    const [availabilityTick, setAvailabilityTick] = useState(0);
    const deliveryAddressInputRef = useRef(null);
    const autocompleteRef = useRef(null);

    // Promotion state
    const [promotionEnabled, setPromotionEnabled] = useState(false);
    const [promotionTitle, setPromotionTitle] = useState('');
    const [promotionType, setPromotionType] = useState('');
    const [promotionValue, setPromotionValue] = useState(0);
    const [promotionMinAmount, setPromotionMinAmount] = useState(0);
    const [promotionDiscount, setPromotionDiscount] = useState(0);

    const [crmPointsConfig, setCrmPointsConfig] = useState(null);
    const [crmMember, setCrmMember] = useState(null);
    const [crmAuthVisible, setCrmAuthVisible] = useState(false);
    const [crmProfileCompletionVisible, setCrmProfileCompletionVisible] = useState(false);
    const [crmRegistrationToken, setCrmRegistrationToken] = useState('');
    const [crmAuthMode, setCrmAuthMode] = useState('password');
    const [crmAuthLoading, setCrmAuthLoading] = useState(false);
    const [crmSmsLoading, setCrmSmsLoading] = useState(false);
    const [crmSmsCountdown, setCrmSmsCountdown] = useState(0);
    const crmSmsTimerRef = useRef(null);
    const crmSmsRequestRef = useRef(false);
    const [crmEmailRequired, setCrmEmailRequired] = useState(false);
    const [crmTermsAccepted, setCrmTermsAccepted] = useState(false);
    const [crmLegalDocument, setCrmLegalDocument] = useState(null);
    const [redeemPoints, setRedeemPoints] = useState(0);
    const [crmPointQuote, setCrmPointQuote] = useState(null);
    const [crmAuthForm, setCrmAuthForm] = useState({
        phone: '', password: '', confirmPassword: '', code: '', firstName: '', middleName: '', lastName: '', email: '', birthday: '', ageGroup: '',
    });

    // Customer Menu Show Price state
    const [showPriceInCustomerMenu, setShowPriceInCustomerMenu] = useState(true);

    const toggleSidePopup = () => {
        setSide_popup(!side_popup);
    };

    const { cart, totalAmount, totalGST, totalQuantity, setCartFromRemote } = useContext(CartContext);
    const { tableNumber, setTableNumber, serviceMode, setServiceMode, storeName, setStoreName, language, uiLanguage, dineInGuestCount } = useContext(ServiceContext);

    const { restaurantUrl, orderId } = useParams();
    const [enableSharedCart, setEnableSharedCart] = useState(false);
    const { isSharedCartReady, syncNotice } = useSharedCart(restaurantUrl, tableNumber, enableSharedCart && serviceMode === 'Dine-in');
    useEffect(() => {
        if (syncNotice) message.warning(sharedCartNoticeText(syncNotice.reason, uiLanguage));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [syncNotice]);
    const cartReady = cart.length > 0 && (!enableSharedCart || serviceMode !== 'Dine-in' || isSharedCartReady);
    const latestCart = useRef(cart);
    latestCart.current = cart;
    const [searchParams] = useSearchParams();

    const [PaymentGateway, setPaymentGateway] = useState(null);
    const [paySecret, setPaySecret] = useState(null); 
    const [tyroOrderAmount, setTyroOrderAmount] = useState(null);
    const [tyroOrderId, setTyroOrderId] = useState(null);
    const [isTyroModalVisible, setIsTyroModalVisible] = useState(false);

    const [isRefundPolicyModalVisible , setIsRefundPolicyModalVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingText, setLoadingText] = useState('');

    const translations = {
        en: {
            openingHours: 'Opening Hours',
            learnMore: 'Learn more',
            cartDetails: 'Cart Details',
            menuItems: 'Menu Items',
            total: 'Total (incl. GST)',
            gst: 'GST',
            toPay: 'To Pay',
            placeOrder: 'Place Order',
            notes: 'Notes',
            addNote: 'Add a note...',
            surcharge: 'Surcharge',
            tableNo: 'Table No',
            dinein: 'Dine-in',
            takeaway: 'Takeaway',
            delivery: 'Delivery',
            deliveryFee: 'Delivery Fee',
            deliveryDistance: 'Delivery Distance',
            estimatedDeliveryFee: 'Estimated Delivery fee',
            orderType: 'Order Type',
            selectOrderType: 'Select order type',
            pleaseSelectOrderType: 'Please select order type',
            calculatingDelivery: 'Calculating delivery fee...',
            pleaseSelectDeliveryAddress: 'Please select a delivery address',
            deliveryOutOfRange: 'Delivery address is outside our delivery range.',
            deliveryMinimumNotMet: 'Delivery order amount is below the minimum of ${amount}.',
            enterYourInformation: 'Enter your information',
            schedule: 'Select a time',
            name: 'Name',
            contactNumber: 'Contact Number',
            address: 'Address',
            confirm: 'Confirm',
            cancel: 'Cancel',
            asap: 'Serve food ASAP',
            pickUpTime: 'Schedule a serving time',
            pleaseEnterInfo: 'Please enter your information',
            pleaseSelectGuestCount: 'Please select the dine-in guest count.',
            sendingOrder: 'Sending Order...',
            memberLogin: 'Member login',
            joinForRewards: 'Join for member rewards',
            memberBenefits: 'Member pricing · points rewards · exclusive offers',
            memberId: 'Member ID',
            logout: 'Log out',
            currentPoints: 'Current points',
            availableCoupons: 'Available coupons',
            mobileNumber: 'Mobile number',
            verificationCode: 'Verification code',
            getCode: 'Get code',
            sending: 'Sending…',
            agreementPrefix: 'I have read and agree to the',
            termsOfUse: 'Terms of Use',
            privacyPolicy: 'Privacy Policy',
            loginRegister: 'Log in / Register',
            agreeToPolicies: 'Please agree to the Terms of Use and Privacy Policy.',
            enterPhoneAndCode: 'Enter your mobile number and verification code.',
            enterMobileFirst: 'Enter your mobile number first.',
            invalidMobile: 'Enter a 10-digit mobile number starting with 04.',
            invalidCode: 'Enter the 6-digit verification code.',
            passwordTooShort: 'Enter at least 6 password characters.',
            passwordLength: 'Password must be 6–16 characters.',
            passwordMismatch: 'Passwords do not match.',
            nameRequired: 'First name and last name are required.',
            ageGroupRequired: 'Select an age group.',
            invalidEmail: 'Email format is invalid.',
            tooManySms: 'Too many messages sent. Please try again later.',
            networkError: 'Network error. Check your connection and try again.',
            memberNotFound: 'Member account not found. Please register first.',
            codeInvalidOrExpired: 'The verification code is incorrect or has expired.',
            phoneAlreadyRegistered: 'This mobile number is already registered.',
            passwordLoginLocked: 'Too many incorrect password attempts. Please use SMS code login.',
            incorrectPassword: 'Password is incorrect. Please try again.',
            incorrectPasswordAttempts: 'Password is incorrect. {count} attempts remaining.',
            serviceUnavailable: 'The member service is temporarily unavailable. Please try again later.',
            passwordLogin: 'Password', smsCodeLogin: 'SMS code', register: 'Register', firstName: 'First name', middleName: 'Middle name', middleNameOptional: 'Middle name (optional)', lastName: 'Last name',
            email: 'Email', emailRequired: 'Email (required)', emailOptional: 'Email (optional)', birthday: 'Birthday', australianMobile: 'Australian mobile number',
            passwordPlaceholder: 'Password (6–16 characters)', confirmPassword: 'Confirm password', selectAgeGroup: 'Select age group', under18: 'Under 18', age65Plus: '65 or older',
            createAccount: 'Create account', login: 'Log in',
            completeDetailsTitle: 'Complete your member profile', completeDetailsHelp: 'Your mobile number is verified. Add your details to create your member account.',
            allNamesRequired: 'First name, middle name and last name are required.', completeRegistration: 'Create member account',
            registrationComplete: 'Your member account has been created.', registrationExpired: 'This registration session has expired. Please request a new code.', registrationFailed: 'Unable to create your member account.',
            verificationCodeSent: 'Verification code sent.',
            sendCodeFailed: 'Unable to send verification code.',
            usePoints: 'Use points on this order',
            useMaximum: 'Use maximum',
            pointsDiscountRate: 'points gives you $1 off.',
            redeemPoints: 'Redeem points',
            redeemAtFinalPayment: 'Applied at final payment',
            redeemAtFinalPaymentHelp: 'Your available points can be redeemed when you make the final payment.',
            rewardsUnavailable: 'Rewards are not available for this membership.',
        },
        ja: {
            openingHours: '営業時間',
            learnMore: 'もっと詳しく',
            cartDetails: 'カートの詳細',
            menuItems: 'メニューアイテム',
            total: '合計 (税込)',
            gst: '消費税',
            toPay: '支払う',
            placeOrder: '注文する',
            notes: 'ノート',
            addNote: 'ノートを追加...',
            surcharge: 'サーチャージ',
            notes: 'ノート',
            tableNo: 'テーブル番号',
            dinein: '店内飲食',
            takeaway: 'テイクアウト',
            delivery: 'Delivery',
            deliveryFee: 'Delivery Fee',
            deliveryDistance: 'Delivery Distance',
            estimatedDeliveryFee: 'Estimated Delivery fee',
            orderType: 'Order Type',
            selectOrderType: 'Select order type',
            pleaseSelectOrderType: 'Please select order type',
            calculatingDelivery: 'Calculating delivery fee...',
            pleaseSelectDeliveryAddress: 'Please select a delivery address',
            deliveryOutOfRange: 'Delivery address is outside our delivery range.',
            enterYourInformation: 'あなたの情報を入力してください',
            schedule: 'スケジュール',
            name: '名前',
            contactNumber: '電話番号',
            address: '住所',
            confirm: '確認',
            cancel: 'キャンセル',
            asap: 'できるだけ早く',
            pickUpTime: '受け取り時間',
            pleaseEnterInfo: '情報を入力してください',
            pleaseSelectGuestCount: '店内飲食人数を選択してください。',
            sendingOrder: '注文を送信しています...',
            memberLogin: '会員ログイン', joinForRewards: '登録して会員特典を利用',
            memberBenefits: '会員価格・ポイント特典・限定オファー', memberId: '会員番号', logout: 'ログアウト',
            currentPoints: '現在のポイント', availableCoupons: '利用可能なクーポン', mobileNumber: '携帯電話番号',
            verificationCode: '認証コード', getCode: 'コードを取得', sending: '送信中…',
            agreementPrefix: '以下を読み、同意します：', termsOfUse: '利用規約', privacyPolicy: 'プライバシーポリシー',
            loginRegister: 'ログイン／登録', agreeToPolicies: '利用規約とプライバシーポリシーに同意してください。',
            enterPhoneAndCode: '携帯電話番号と認証コードを入力してください。', enterMobileFirst: '先に携帯電話番号を入力してください。',
            invalidMobile: '04から始まる10桁の携帯電話番号を入力してください。',
            invalidCode: '6桁の認証コードを入力してください。', passwordTooShort: '6文字以上のパスワードを入力してください。',
            passwordLength: 'パスワードは6～16文字で入力してください。', passwordMismatch: 'パスワードが一致しません。',
            nameRequired: '名と姓を入力してください。', ageGroupRequired: '年齢層を選択してください。', invalidEmail: 'メールアドレスの形式が正しくありません。',
            tooManySms: '送信回数が多すぎます。しばらくしてからお試しください。', networkError: 'ネットワーク接続を確認して再試行してください。',
            memberNotFound: '会員アカウントが見つかりません。先に登録してください。', codeInvalidOrExpired: '認証コードが正しくないか期限切れです。',
            phoneAlreadyRegistered: 'この携帯電話番号は登録済みです。', passwordLoginLocked: 'パスワードの誤入力が多すぎます。SMSコードでログインしてください。',
            incorrectPassword: 'パスワードが正しくありません。', serviceUnavailable: '会員サービスは一時的に利用できません。',
            incorrectPasswordAttempts: 'パスワードが正しくありません。残り{count}回です。',
            passwordLogin: 'パスワード', smsCodeLogin: 'SMSコード', register: '登録', firstName: '名', middleName: 'ミドルネーム', middleNameOptional: 'ミドルネーム（任意）', lastName: '姓',
            email: 'メール', emailRequired: 'メール（必須）', emailOptional: 'メール（任意）', birthday: '誕生日', australianMobile: 'オーストラリアの携帯電話番号',
            passwordPlaceholder: 'パスワード（6～16文字）', confirmPassword: 'パスワード確認', selectAgeGroup: '年齢層を選択', under18: '18歳未満', age65Plus: '65歳以上',
            createAccount: 'アカウントを作成', login: 'ログイン',
            completeDetailsTitle: '会員情報を入力', completeDetailsHelp: '携帯電話番号の確認が完了しました。会員アカウント作成のため情報を入力してください。',
            allNamesRequired: '名、ミドルネーム、姓をすべて入力してください。', completeRegistration: '会員アカウントを作成',
            registrationComplete: '会員アカウントを作成しました。', registrationExpired: '登録セッションの期限が切れました。新しいコードを取得してください。', registrationFailed: '会員アカウントを作成できませんでした。',
            verificationCodeSent: '認証コードを送信しました。', sendCodeFailed: '認証コードを送信できませんでした。',
            usePoints: 'この注文でポイントを使う', useMaximum: '最大まで使う', pointsDiscountRate: 'ポイントで1ドル割引になります。', redeemPoints: 'ポイントを利用', redeemAtFinalPayment: '最終支払い時に適用', redeemAtFinalPaymentHelp: '利用可能なポイントは、最終支払い時にご利用いただけます。',
            rewardsUnavailable: 'この会員ではポイント特典を利用できません。',
        },
        zh: {
            openingHours: '营业时间',
            learnMore: '了解更多',
            cartDetails: '购物车详情',
            menuItems: '菜品',
            total: '总计 (含GST)',
            gst: '消费税',
            toPay: '支付',
            placeOrder: '下单',
            notes: '备注',
            
            addNote: '添加备注...',
            surcharge: '附加费',
            notes: '备注',
            tableNo: '桌号',
            dinein: '堂食',
            takeaway: '外卖',
            delivery: '配送',
            deliveryFee: '配送费',
            deliveryDistance: '配送距离',
            estimatedDeliveryFee: '预计配送费',
            orderType: '订单类型',
            selectOrderType: '选择订单类型',
            pleaseSelectOrderType: '请选择订单类型',
            calculatingDelivery: '正在计算配送费...',
            pleaseSelectDeliveryAddress: '请选择配送地址',
            deliveryOutOfRange: '超出配送涵盖范围',
            deliveryMinimumNotMet: '配送订单金额不足，最低下单金额为 ${amount}。',
            enterYourInformation: '输入您的信息',
            schedule: '选择时间',
            name: '姓名',
            contactNumber: '联系电话',
            address: '地址',
            confirm: '确认',
            cancel: '取消',
            asap: '尽快取餐',
            pickUpTime: '取餐时间',
            pleaseEnterInfo: '请输入您的信息',
            pleaseSelectGuestCount: '请选择就餐人数',
            sendingOrder: '发送订单中...',
            memberLogin: '会员登录', joinForRewards: '登录享会员优惠',
            memberBenefits: '优惠券 · 积分抵扣 · 会员专享价', memberId: '会员卡号', logout: '退出登录',
            currentPoints: '当前积分', availableCoupons: '可用优惠券', mobileNumber: '请输入手机号',
            verificationCode: '请输入验证码', getCode: '获取验证码', sending: '发送中…',
            agreementPrefix: '我已阅读并同意', termsOfUse: '用户协议', privacyPolicy: '隐私政策',
            loginRegister: '登录/注册', agreeToPolicies: '请先同意用户协议和隐私政策。',
            enterPhoneAndCode: '请输入手机号和验证码。', enterMobileFirst: '请先输入手机号。',
            invalidMobile: '请输入04开头的10位手机号码。',
            invalidCode: '请输入6位验证码。', passwordTooShort: '请输入至少6位密码。', passwordLength: '密码长度需要6–16位。',
            passwordMismatch: '两次输入的密码不一致。', nameRequired: '名字和姓氏不能为空。', ageGroupRequired: '请选择年龄段。',
            invalidEmail: '邮箱格式不正确。', tooManySms: '发送次数过多，请稍后重试。', networkError: '网络连接异常，请检查网络后重试。',
            memberNotFound: '未找到会员账号，请先注册。', codeInvalidOrExpired: '验证码不正确或已过期。', phoneAlreadyRegistered: '该手机号已注册。',
            passwordLoginLocked: '密码错误次数过多，请使用验证码登录。', incorrectPassword: '密码不正确，请重新输入。', serviceUnavailable: '会员服务暂时不可用，请稍后重试。',
            incorrectPasswordAttempts: '密码不正确，还可尝试{count}次。',
            passwordLogin: '密码登录', smsCodeLogin: '短信验证码', register: '注册', firstName: '名字', middleName: '中间名', middleNameOptional: '中间名（选填）', lastName: '姓氏',
            email: '邮箱', emailRequired: '邮箱（必填）', emailOptional: '邮箱（选填）', birthday: '生日', australianMobile: '澳大利亚手机号码',
            passwordPlaceholder: '密码（6–16位）', confirmPassword: '确认密码', selectAgeGroup: '选择年龄段', under18: '18岁以下', age65Plus: '65岁及以上',
            createAccount: '创建账号', login: '登录',
            completeDetailsTitle: '完善会员资料', completeDetailsHelp: '手机号码已验证，请补充资料以创建会员账号。',
            allNamesRequired: '名字、中间名和姓氏都必须填写。', completeRegistration: '创建会员账号',
            registrationComplete: '会员账号已创建。', registrationExpired: '本次注册已过期，请重新获取验证码。', registrationFailed: '无法创建会员账号，请稍后重试。',
            verificationCodeSent: '验证码已发送。', sendCodeFailed: '验证码发送失败。',
            usePoints: '本单使用积分', useMaximum: '使用最多积分', pointsDiscountRate: '积分可抵扣1澳元。', redeemPoints: '积分抵扣', redeemAtFinalPayment: '将在最终付款时抵用', redeemAtFinalPaymentHelp: '您的可用积分可在最终付款时抵用。',
            rewardsUnavailable: '该会员暂不可使用积分权益。',
        },
        zf: {
            openingHours: '營業時間',
            learnMore: '了解更多',
            cartDetails: '購物車詳情',
            menuItems: '菜品',
            total: '總計 (含GST)',
            gst: '消費稅',
            toPay: '支付',
            placeOrder: '下單',
            notes: '備註',
            
            addNote: '添加備註...',
            surcharge: '附加費',
            tableNo: '桌號',
            dinein: '堂食',
            takeaway: '外賣',
            delivery: '配送',
            deliveryFee: '配送費',
            deliveryDistance: '配送距離',
            estimatedDeliveryFee: '預計配送費',
            orderType: '訂單類型',
            selectOrderType: '選擇訂單類型',
            pleaseSelectOrderType: '請選擇訂單類型',
            calculatingDelivery: '正在計算配送費...',
            pleaseSelectDeliveryAddress: '請選擇配送地址',
            deliveryOutOfRange: '超出配送涵蓋範圍',
            enterYourInformation: '輸入您的信息',
            schedule: '時間表',
            name: '姓名',
            contactNumber: '聯繫電話',
            address: '地址',
            confirm: '確認',
            cancel: '取消',
            asap: '儘快取餐',
            pickUpTime: '取餐時間',
            pleaseEnterInfo: '請輸入您的信息',
            pleaseSelectGuestCount: '請選擇就餐人數',
            sendingOrder: '發送訂單中...',
            memberLogin: '會員登入', joinForRewards: '登入享會員優惠',
            memberBenefits: '優惠券 · 積分抵扣 · 會員專享價', memberId: '會員卡號', logout: '退出登入',
            currentPoints: '目前積分', availableCoupons: '可用優惠券', mobileNumber: '請輸入手機號碼',
            verificationCode: '請輸入驗證碼', getCode: '取得驗證碼', sending: '發送中…',
            agreementPrefix: '我已閱讀並同意', termsOfUse: '用戶協議', privacyPolicy: '隱私政策',
            loginRegister: '登入/註冊', agreeToPolicies: '請先同意用戶協議和隱私政策。',
            enterPhoneAndCode: '請輸入手機號碼和驗證碼。', enterMobileFirst: '請先輸入手機號碼。',
            invalidMobile: '請輸入04開頭的10位手機號碼。',
            invalidCode: '請輸入6位驗證碼。', passwordTooShort: '請輸入至少6位密碼。', passwordLength: '密碼長度需要6–16位。',
            passwordMismatch: '兩次輸入的密碼不一致。', nameRequired: '名字和姓氏不能為空。', ageGroupRequired: '請選擇年齡層。',
            invalidEmail: '電郵格式不正確。', tooManySms: '發送次數過多，請稍後再試。', networkError: '網絡連線異常，請檢查後再試。',
            memberNotFound: '未找到會員帳號，請先註冊。', codeInvalidOrExpired: '驗證碼不正確或已過期。', phoneAlreadyRegistered: '該手機號碼已註冊。',
            passwordLoginLocked: '密碼錯誤次數過多，請使用驗證碼登入。', incorrectPassword: '密碼不正確，請重新輸入。', serviceUnavailable: '會員服務暫時不可用，請稍後再試。',
            incorrectPasswordAttempts: '密碼不正確，還可嘗試{count}次。',
            passwordLogin: '密碼登入', smsCodeLogin: '短訊驗證碼', register: '註冊', firstName: '名字', middleName: '中間名', middleNameOptional: '中間名（選填）', lastName: '姓氏',
            email: '電郵', emailRequired: '電郵（必填）', emailOptional: '電郵（選填）', birthday: '生日', australianMobile: '澳洲手機號碼',
            passwordPlaceholder: '密碼（6–16位）', confirmPassword: '確認密碼', selectAgeGroup: '選擇年齡層', under18: '18歲以下', age65Plus: '65歲及以上',
            createAccount: '建立帳號', login: '登入',
            completeDetailsTitle: '完善會員資料', completeDetailsHelp: '手機號碼已驗證，請補充資料以建立會員帳號。',
            allNamesRequired: '名字、中間名和姓氏都必須填寫。', completeRegistration: '建立會員帳號',
            registrationComplete: '會員帳號已建立。', registrationExpired: '本次註冊已過期，請重新取得驗證碼。', registrationFailed: '無法建立會員帳號，請稍後再試。',
            verificationCodeSent: '驗證碼已發送。', sendCodeFailed: '驗證碼發送失敗。',
            usePoints: '本單使用積分', useMaximum: '使用最多積分', pointsDiscountRate: '積分可抵扣1澳元。', redeemPoints: '積分抵扣', redeemAtFinalPayment: '將在最終付款時抵用', redeemAtFinalPaymentHelp: '您的可用積分可在最終付款時抵用。',
            rewardsUnavailable: '該會員暫不可使用積分權益。',
        },
        ko: {
            openingHours: '영업 시간',
            learnMore: '더 알아보기',
            cartDetails: '장바구니 세부 정보',
            menuItems: '메뉴 항목',
            total: '합계 (부가세 포함)',
            gst: '부가세',
            toPay: '지불',
            placeOrder: '주문하기',
            notes: '노트',
            addNote: '노트 추가...',
            surcharge: '추가 요금',
            notes: '노트',
            tableNo: '테이블 번호',
            dinein: '매장 식사',
            takeaway: '포장',
            delivery: 'Delivery',
            deliveryFee: 'Delivery Fee',
            deliveryDistance: 'Delivery Distance',
            estimatedDeliveryFee: 'Estimated Delivery fee',
            orderType: 'Order Type',
            selectOrderType: 'Select order type',
            pleaseSelectOrderType: 'Please select order type',
            calculatingDelivery: 'Calculating delivery fee...',
            pleaseSelectDeliveryAddress: 'Please select a delivery address',
            deliveryOutOfRange: 'Delivery address is outside our delivery range.',
            enterYourInformation: '정보를 입력하세요',
            schedule: '시간 선택',
            name: '이름',
            contactNumber: '연락처',
            address: '주소',
            confirm: '확인',
            cancel: '취소',
            asap: '가능한 빨리',
            pickUpTime: '픽업 시간',
            pleaseEnterInfo: '정보를 입력하세요',
            pleaseSelectGuestCount: '매장 식사 인원을 선택해주세요.',
            sendingOrder: '주문 중...',
            memberLogin: '회원 로그인', joinForRewards: '가입하고 회원 혜택 받기',
            memberBenefits: '회원 가격 · 포인트 혜택 · 전용 할인', memberId: '회원 번호', logout: '로그아웃',
            currentPoints: '현재 포인트', availableCoupons: '사용 가능한 쿠폰', mobileNumber: '휴대폰 번호',
            verificationCode: '인증 코드', getCode: '코드 받기', sending: '전송 중…',
            agreementPrefix: '다음 내용을 읽고 동의합니다:', termsOfUse: '이용약관', privacyPolicy: '개인정보 처리방침',
            loginRegister: '로그인 / 가입', agreeToPolicies: '이용약관과 개인정보 처리방침에 동의해 주세요.',
            enterPhoneAndCode: '휴대폰 번호와 인증 코드를 입력해 주세요.', enterMobileFirst: '먼저 휴대폰 번호를 입력해 주세요.',
            invalidMobile: '04로 시작하는 10자리 휴대폰 번호를 입력해 주세요.',
            invalidCode: '6자리 인증 코드를 입력해 주세요.', passwordTooShort: '6자 이상의 비밀번호를 입력해 주세요.', passwordLength: '비밀번호는 6–16자여야 합니다.',
            passwordMismatch: '비밀번호가 일치하지 않습니다.', nameRequired: '이름과 성을 입력해 주세요.', ageGroupRequired: '연령대를 선택해 주세요.', invalidEmail: '이메일 형식이 올바르지 않습니다.',
            tooManySms: '전송 횟수가 너무 많습니다. 나중에 다시 시도해 주세요.', networkError: '네트워크 연결을 확인하고 다시 시도해 주세요.',
            memberNotFound: '회원 계정을 찾을 수 없습니다. 먼저 가입해 주세요.', codeInvalidOrExpired: '인증 코드가 잘못되었거나 만료되었습니다.',
            phoneAlreadyRegistered: '이미 등록된 휴대폰 번호입니다.', passwordLoginLocked: '비밀번호 오류가 너무 많습니다. SMS 코드로 로그인해 주세요.',
            incorrectPassword: '비밀번호가 올바르지 않습니다.', serviceUnavailable: '회원 서비스를 일시적으로 사용할 수 없습니다.',
            incorrectPasswordAttempts: '비밀번호가 올바르지 않습니다. {count}회 남았습니다.',
            passwordLogin: '비밀번호', smsCodeLogin: 'SMS 코드', register: '가입', firstName: '이름', middleName: '중간 이름', middleNameOptional: '중간 이름 (선택)', lastName: '성',
            email: '이메일', emailRequired: '이메일 (필수)', emailOptional: '이메일 (선택)', birthday: '생일', australianMobile: '호주 휴대폰 번호',
            passwordPlaceholder: '비밀번호 (6–16자)', confirmPassword: '비밀번호 확인', selectAgeGroup: '연령대 선택', under18: '18세 미만', age65Plus: '65세 이상',
            createAccount: '계정 만들기', login: '로그인',
            completeDetailsTitle: '회원 정보 입력', completeDetailsHelp: '휴대폰 번호가 확인되었습니다. 회원 계정을 만들려면 정보를 입력해 주세요.',
            allNamesRequired: '이름, 중간 이름, 성을 모두 입력해 주세요.', completeRegistration: '회원 계정 만들기',
            registrationComplete: '회원 계정이 생성되었습니다.', registrationExpired: '등록 시간이 만료되었습니다. 새 코드를 요청해 주세요.', registrationFailed: '회원 계정을 만들 수 없습니다.',
            verificationCodeSent: '인증 코드를 전송했습니다.', sendCodeFailed: '인증 코드를 전송하지 못했습니다.',
            usePoints: '이 주문에 포인트 사용', useMaximum: '최대 사용', pointsDiscountRate: '포인트로 $1 할인됩니다.', redeemPoints: '포인트 사용', redeemAtFinalPayment: '최종 결제 시 적용', redeemAtFinalPaymentHelp: '사용 가능한 포인트는 최종 결제 시 사용할 수 있습니다.',
            rewardsUnavailable: '이 회원권에는 포인트 혜택을 사용할 수 없습니다.',
        },
       
        vi: {
            openingHours: 'Giờ mở cửa',
            learnMore: 'Tìm hiểu thêm',
            cartDetails: 'Chi tiết giỏ hàng',
            menuItems: 'Mục menu',
            total: 'Tổng cộng (bao gồm thuế GTGT)',
            gst: 'Thuế GTGT',
            toPay: 'Thanh toán',
            placeOrder: 'Đặt hàng',
            notes: 'Ghi chú',   
            addNote: 'Thêm ghi chú...',
            surcharge: 'Phụ phí',
            notes: 'Ghi chú',
            tableNo: 'Số bàn',
            dinein: 'Dine-in',
            takeaway: 'Takeaway',
            delivery: 'Delivery',
            deliveryFee: 'Delivery Fee',
            deliveryDistance: 'Delivery Distance',
            estimatedDeliveryFee: 'Estimated Delivery fee',
            orderType: 'Order Type',
            selectOrderType: 'Select order type',
            pleaseSelectOrderType: 'Please select order type',
            calculatingDelivery: 'Calculating delivery fee...',
            pleaseSelectDeliveryAddress: 'Please select a delivery address',
            deliveryOutOfRange: 'Delivery address is outside our delivery range.',
            enterYourInformation: 'Nhập thông tin của bạn',
            schedule: 'Chọn thởi gian',
            name: 'Tên',
            contactNumber: 'Số điện thoại liên hệ',
            address: 'Địa chỉ',
            confirm: 'Xác nhận',
            cancel: 'Hủy',
            asap: 'Phục vụ thức ăn ngay',
            pickUpTime: 'Chọn thời gian lấy hàng',
            pleaseEnterInfo: 'Vui lòng nhập thông tin của bạn',
            pleaseSelectGuestCount: 'Vui lòng chọn số khách.',
            sendingOrder: 'Đang gửi đơn hàng...',
            memberLogin: 'Đăng nhập thành viên', joinForRewards: 'Tham gia để nhận ưu đãi',
            memberBenefits: 'Giá thành viên · điểm thưởng · ưu đãi độc quyền', memberId: 'Mã thành viên', logout: 'Đăng xuất',
            currentPoints: 'Điểm hiện tại', availableCoupons: 'Phiếu ưu đãi khả dụng', mobileNumber: 'Số điện thoại',
            verificationCode: 'Mã xác minh', getCode: 'Lấy mã', sending: 'Đang gửi…',
            agreementPrefix: 'Tôi đã đọc và đồng ý với', termsOfUse: 'Điều khoản sử dụng', privacyPolicy: 'Chính sách bảo mật',
            loginRegister: 'Đăng nhập / Đăng ký', agreeToPolicies: 'Vui lòng đồng ý với Điều khoản sử dụng và Chính sách bảo mật.',
            enterPhoneAndCode: 'Nhập số điện thoại và mã xác minh.', enterMobileFirst: 'Vui lòng nhập số điện thoại trước.',
            invalidMobile: 'Nhập số điện thoại 10 chữ số bắt đầu bằng 04.',
            invalidCode: 'Nhập mã xác minh gồm 6 chữ số.', passwordTooShort: 'Nhập mật khẩu có ít nhất 6 ký tự.', passwordLength: 'Mật khẩu phải có 6–16 ký tự.',
            passwordMismatch: 'Mật khẩu không khớp.', nameRequired: 'Tên và họ là bắt buộc.', ageGroupRequired: 'Chọn nhóm tuổi.', invalidEmail: 'Định dạng email không hợp lệ.',
            tooManySms: 'Đã gửi quá nhiều tin nhắn. Vui lòng thử lại sau.', networkError: 'Lỗi mạng. Kiểm tra kết nối và thử lại.',
            memberNotFound: 'Không tìm thấy tài khoản. Vui lòng đăng ký trước.', codeInvalidOrExpired: 'Mã xác minh không đúng hoặc đã hết hạn.',
            phoneAlreadyRegistered: 'Số điện thoại này đã được đăng ký.', passwordLoginLocked: 'Sai mật khẩu quá nhiều lần. Hãy đăng nhập bằng mã SMS.',
            incorrectPassword: 'Mật khẩu không đúng.', serviceUnavailable: 'Dịch vụ thành viên tạm thời không khả dụng.',
            incorrectPasswordAttempts: 'Mật khẩu không đúng. Còn {count} lần thử.',
            passwordLogin: 'Mật khẩu', smsCodeLogin: 'Mã SMS', register: 'Đăng ký', firstName: 'Tên', middleName: 'Tên đệm', middleNameOptional: 'Tên đệm (không bắt buộc)', lastName: 'Họ',
            email: 'Email', emailRequired: 'Email (bắt buộc)', emailOptional: 'Email (không bắt buộc)', birthday: 'Ngày sinh', australianMobile: 'Số điện thoại Úc',
            passwordPlaceholder: 'Mật khẩu (6–16 ký tự)', confirmPassword: 'Xác nhận mật khẩu', selectAgeGroup: 'Chọn nhóm tuổi', under18: 'Dưới 18', age65Plus: 'Từ 65 tuổi',
            createAccount: 'Tạo tài khoản', login: 'Đăng nhập',
            completeDetailsTitle: 'Hoàn tất hồ sơ thành viên', completeDetailsHelp: 'Số điện thoại đã được xác minh. Hãy bổ sung thông tin để tạo tài khoản.',
            allNamesRequired: 'Tên, tên đệm và họ đều bắt buộc.', completeRegistration: 'Tạo tài khoản thành viên',
            registrationComplete: 'Tài khoản thành viên đã được tạo.', registrationExpired: 'Phiên đăng ký đã hết hạn. Vui lòng yêu cầu mã mới.', registrationFailed: 'Không thể tạo tài khoản thành viên.',
            verificationCodeSent: 'Đã gửi mã xác minh.', sendCodeFailed: 'Không thể gửi mã xác minh.',
            usePoints: 'Dùng điểm cho đơn hàng', useMaximum: 'Dùng tối đa', pointsDiscountRate: 'điểm được giảm $1.', redeemPoints: 'Đổi điểm', redeemAtFinalPayment: 'Áp dụng khi thanh toán cuối cùng', redeemAtFinalPaymentHelp: 'Điểm hiện có của bạn có thể được sử dụng khi thanh toán cuối cùng.',
            rewardsUnavailable: 'Điểm thưởng không khả dụng cho thành viên này.',
        },
        th: {
            openingHours: 'เวลาเปิด-ปิด',
            learnMore: 'เรียนรู้เพิ่มเติม',
            cartDetails: 'รายละเอียดตะกร้า',
            menuItems: 'รายการเมนู',
            total: 'รวม (รวมภาษีมูลค่าเพิ่ม)',
            gst: 'ภาษีมูลค่าเพิ่ม',
            toPay: 'ชำระเงิน',
            placeOrder: 'สั่งซื้อ',
            notes: 'บันทึก',
            addNote: 'เพิ่มบันทึก...',
            surcharge: 'ค่าธรรมเนียมเพิ่ม',
            notes: 'บันทึก',
            tableNo: 'หมายเลขโต๊ะ',
            dinein: 'ทานในร้าน',
            takeaway: 'ห่อกลับ',
            delivery: 'Delivery',
            deliveryFee: 'Delivery Fee',
            deliveryDistance: 'Delivery Distance',
            estimatedDeliveryFee: 'Estimated Delivery fee',
            orderType: 'Order Type',
            selectOrderType: 'Select order type',
            pleaseSelectOrderType: 'Please select order type',
            calculatingDelivery: 'Calculating delivery fee...',
            pleaseSelectDeliveryAddress: 'Please select a delivery address',
            deliveryOutOfRange: 'Delivery address is outside our delivery range.',
            enterYourInformation: 'ป้อนข้อมูลของคุณ',
            schedule: 'เลือกเวลา',
            name: 'ชื่อ',
            contactNumber: 'หมายเลขติดต่อ',
            address: 'ที่อยู่',
            confirm: 'ยืนยัน',
            cancel: 'ยกเลิก',
            asap: 'เสิร์ฟอาหารโดยเร็วที่สุด',
            pickUpTime: 'เลือกเวลารับอาหาร',
            pleaseEnterInfo: 'โปรดป้อนข้อมูลของคุณ',
            pleaseSelectGuestCount: 'โปรดเลือกจำนวนผู้เข้าพัก',
            sendingOrder: 'กําลังส่งคำสั่งซื้อ...',
            memberLogin: 'เข้าสู่ระบบสมาชิก', joinForRewards: 'สมัครเพื่อรับสิทธิพิเศษ',
            memberBenefits: 'ราคาสมาชิก · คะแนนสะสม · ข้อเสนอพิเศษ', memberId: 'หมายเลขสมาชิก', logout: 'ออกจากระบบ',
            currentPoints: 'คะแนนปัจจุบัน', availableCoupons: 'คูปองที่ใช้ได้', mobileNumber: 'หมายเลขมือถือ',
            verificationCode: 'รหัสยืนยัน', getCode: 'รับรหัส', sending: 'กำลังส่ง…',
            agreementPrefix: 'ฉันได้อ่านและยอมรับ', termsOfUse: 'ข้อกำหนดการใช้งาน', privacyPolicy: 'นโยบายความเป็นส่วนตัว',
            loginRegister: 'เข้าสู่ระบบ / สมัคร', agreeToPolicies: 'โปรดยอมรับข้อกำหนดการใช้งานและนโยบายความเป็นส่วนตัว',
            enterPhoneAndCode: 'กรอกหมายเลขมือถือและรหัสยืนยัน', enterMobileFirst: 'กรุณากรอกหมายเลขมือถือก่อน',
            invalidMobile: 'กรอกหมายเลขมือถือ 10 หลักที่ขึ้นต้นด้วย 04',
            invalidCode: 'กรอกรหัสยืนยัน 6 หลัก', passwordTooShort: 'กรอกรหัสผ่านอย่างน้อย 6 ตัวอักษร', passwordLength: 'รหัสผ่านต้องมี 6–16 ตัวอักษร',
            passwordMismatch: 'รหัสผ่านไม่ตรงกัน', nameRequired: 'ต้องระบุชื่อและนามสกุล', ageGroupRequired: 'เลือกช่วงอายุ', invalidEmail: 'รูปแบบอีเมลไม่ถูกต้อง',
            tooManySms: 'ส่งข้อความมากเกินไป โปรดลองอีกครั้งภายหลัง', networkError: 'เกิดข้อผิดพลาดเครือข่าย โปรดตรวจสอบการเชื่อมต่อ',
            memberNotFound: 'ไม่พบบัญชีสมาชิก โปรดสมัครก่อน', codeInvalidOrExpired: 'รหัสยืนยันไม่ถูกต้องหรือหมดอายุ',
            phoneAlreadyRegistered: 'หมายเลขนี้ลงทะเบียนแล้ว', passwordLoginLocked: 'ใส่รหัสผ่านผิดหลายครั้ง โปรดเข้าสู่ระบบด้วยรหัส SMS',
            incorrectPassword: 'รหัสผ่านไม่ถูกต้อง', serviceUnavailable: 'บริการสมาชิกไม่พร้อมใช้งานชั่วคราว',
            incorrectPasswordAttempts: 'รหัสผ่านไม่ถูกต้อง เหลือลองได้อีก {count} ครั้ง',
            passwordLogin: 'รหัสผ่าน', smsCodeLogin: 'รหัส SMS', register: 'สมัคร', firstName: 'ชื่อ', middleName: 'ชื่อกลาง', middleNameOptional: 'ชื่อกลาง (ไม่บังคับ)', lastName: 'นามสกุล',
            email: 'อีเมล', emailRequired: 'อีเมล (จำเป็น)', emailOptional: 'อีเมล (ไม่บังคับ)', birthday: 'วันเกิด', australianMobile: 'หมายเลขมือถือออสเตรเลีย',
            passwordPlaceholder: 'รหัสผ่าน (6–16 ตัวอักษร)', confirmPassword: 'ยืนยันรหัสผ่าน', selectAgeGroup: 'เลือกช่วงอายุ', under18: 'ต่ำกว่า 18 ปี', age65Plus: '65 ปีขึ้นไป',
            createAccount: 'สร้างบัญชี', login: 'เข้าสู่ระบบ',
            completeDetailsTitle: 'กรอกข้อมูลสมาชิก', completeDetailsHelp: 'ยืนยันหมายเลขมือถือแล้ว กรุณากรอกข้อมูลเพื่อสร้างบัญชีสมาชิก',
            allNamesRequired: 'ต้องกรอกชื่อ ชื่อกลาง และนามสกุล', completeRegistration: 'สร้างบัญชีสมาชิก',
            registrationComplete: 'สร้างบัญชีสมาชิกแล้ว', registrationExpired: 'เซสชันการสมัครหมดอายุ กรุณาขอรหัสใหม่', registrationFailed: 'ไม่สามารถสร้างบัญชีสมาชิกได้',
            verificationCodeSent: 'ส่งรหัสยืนยันแล้ว', sendCodeFailed: 'ไม่สามารถส่งรหัสยืนยันได้',
            usePoints: 'ใช้คะแนนกับคำสั่งซื้อนี้', useMaximum: 'ใช้สูงสุด', pointsDiscountRate: 'คะแนนลดได้ $1', redeemPoints: 'แลกคะแนน', redeemAtFinalPayment: 'ใช้เมื่อชำระเงินครั้งสุดท้าย', redeemAtFinalPaymentHelp: 'คะแนนที่มีอยู่สามารถใช้ได้เมื่อชำระเงินครั้งสุดท้าย',
            rewardsUnavailable: 'สมาชิกนี้ไม่สามารถใช้คะแนนสะสมได้',
        },
    
    };

    const ui = (key) => translations[uiLanguage] ? translations[uiLanguage][key] : translations['en'][key];

    const getCooldownMessage = (items, code) => {
        if (!items || items.length === 0) {
            return 'This item is cooling down. Please try again later.';
        }
        if (code === 'ITEM_PER_PERSON_LIMIT_REACHED') {
            return items
                .map(item => `${item.description || item.itemCode}: maximum ${item.maxQuantity} for this table`)
                .join('\n');
        }
        return items
            .map(item => `${item.description || item.itemCode}: ${item.remainingSeconds}s remaining`)
            .join('\n');
    };

    const handleCooldownError = (error) => {
        message.warning(getCooldownMessage(error?.response?.data?.items, error?.response?.data?.code));
    };

    const isMenuItemConflictError = (error) => {
        const code = error?.response?.data?.code;
        return error?.response?.status === 409
            && (code === 'ITEM_COOLDOWN_ACTIVE' || code === 'ITEM_PER_PERSON_LIMIT_REACHED');
    };

    const ensureMenuItemCooldownAvailable = async (effectiveServiceMode) => {
        if (effectiveServiceMode !== 'Dine-in') {
            return true;
        }
        const hasCooldownItems = cart.some(order => Number(order?.[1]?.orderCooldownSeconds) > 0);
        if (!hasCooldownItems) {
            return true;
        }
        try {
            await axios.post(`${process.env.REACT_APP_SERVER_URL}/check-menu-item-cooldowns`, {
                storeId,
                tableNumber,
                serviceMode: effectiveServiceMode,
                cart,
            });
            return true;
        } catch (error) {
            if (isMenuItemConflictError(error)) {
                handleCooldownError(error);
                return false;
            }
            throw error;
        }
    };

    const rememberSubmittedMenuItemCooldowns = (effectiveServiceMode) => {
        if (effectiveServiceMode !== 'Dine-in') {
            return;
        }
        const now = Date.now();
        const cooldownItems = cart
            .map(order => order && order[1])
            .filter(item => item && Number(item.orderCooldownSeconds) > 0)
            .map(item => ({
                itemCode: String(item.mainItemCode),
                remainingSeconds: Number(item.orderCooldownSeconds),
                expiresAt: now + Number(item.orderCooldownSeconds) * 1000,
            }));
        if (cooldownItems.length === 0) {
            return;
        }
        sessionStorage.setItem('menuItemCooldowns', JSON.stringify({
            storeId,
            tableNumber,
            items: cooldownItems,
        }));
    };

    useEffect(() => {
        // 当组件加载完成后，滚动到页面顶部
        window.scrollTo(0, 0);
    }, []);

    // Calculate promotion discount
    useEffect(() => {
        if (promotionEnabled && totalAmount > 0) {
            // Check if order meets minimum amount requirement
            if (promotionMinAmount > 0 && totalAmount < promotionMinAmount) {
                setPromotionDiscount(0);
                return;
            }

            let discount = 0;
            if (promotionType === 'percentage') {
                // Percentage discount
                discount = (totalAmount * promotionValue) / 100;
            } else if (promotionType === 'amount') {
                // Fixed amount discount
                discount = promotionValue;
            }
            
            // Ensure discount doesn't exceed total amount
            discount = Math.min(discount, totalAmount);
            setPromotionDiscount(parseFloat(discount.toFixed(2)));
        } else {
            setPromotionDiscount(0);
        }
    }, [promotionEnabled, totalAmount, promotionType, promotionValue, promotionMinAmount]);

    const getDeliveryFee = () => orderServiceMode === 'Delivery' && deliveryQuote ? Number(deliveryQuote.deliveryFee || 0) : 0;

    const getOrderBaseAmount = () => (
        parseFloat(totalAmount || 0)
        - parseFloat(promotionDiscount || 0)
        + (parseFloat(surcharges) || 0) * (
            serviceType === 1
                ? Math.max(0, parseFloat(totalAmount || 0) - parseFloat(promotionDiscount || 0))
                : parseFloat(totalAmount || 0)
        ) / 100
    );

    const getFinalOrderAmount = () => (getOrderBaseAmount() + getDeliveryFee()).toFixed(2);

    const getPayableOrderAmount = () => (
        crmPointQuote?.paidAmountCents == null
            ? Number(getFinalOrderAmount())
            : Number(crmPointQuote.paidAmountCents) / 100
    ).toFixed(2);

    const getDisplayedSurchargeAmount = () => (
        serviceType === 1 && crmPointQuote?.surchargeCents != null
            ? Number(crmPointQuote.surchargeCents) / 100
            : (parseFloat(surcharges) || 0) * (
                serviceType === 1
                    ? Math.max(0, parseFloat(totalAmount || 0) - parseFloat(promotionDiscount || 0))
                    : parseFloat(totalAmount || 0)
            ) / 100
    );

    const applyCrmMember = (member) => {
        setCrmMember(member || null);
        if (!member) return;
        const fullAddress = [member.address, member.suburb, member.state, member.postCode]
            .filter(Boolean).join(', ');
        setUserInfo((current) => ({
            name: current.name || member.customerName || '',
            contactNumber: current.contactNumber || member.mobile || '',
            address: current.address || fullAddress,
        }));
    };

    const loadCrmMember = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/api/crm-member/me/${restaurantUrl}`,
                { withCredentials: true }
            );
            applyCrmMember(response.data.member);
        } catch (error) {
            if (error.response?.status !== 401) console.error('Unable to load CRM member:', error);
            applyCrmMember(null);
        }
    };

    const openCrmAuth = async () => {
        setCrmAuthVisible(true);
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/api/crm-member/settings/${restaurantUrl}`,
                { withCredentials: true }
            );
            setCrmEmailRequired(Number(response.data.customerRegisterEmailRequired || 0) === 1);
        } catch (error) {
            console.error('Unable to load CRM registration settings:', error);
        }
    };

    const isValidCrmMobile = (phone) => /^04\d{8}$/.test(String(phone || '').trim());

    const startCrmSmsCountdown = () => {
        if (crmSmsTimerRef.current) clearInterval(crmSmsTimerRef.current);
        setCrmSmsCountdown(60);
        crmSmsTimerRef.current = setInterval(() => {
            setCrmSmsCountdown((current) => {
                if (current <= 1) {
                    clearInterval(crmSmsTimerRef.current);
                    crmSmsTimerRef.current = null;
                    return 0;
                }
                return current - 1;
            });
        }, 1000);
    };

    useEffect(() => () => {
        if (crmSmsTimerRef.current) clearInterval(crmSmsTimerRef.current);
    }, []);

    const getCrmAuthError = (error, fallbackKey = 'serviceUnavailable') => {
        const data = error.response?.data || {};
        const errorValue = typeof data.error === 'string' ? data.error : data.error?.code;
        const code = String(data.code || errorValue || '').toUpperCase();
        const rawMessage = String(data.message || (typeof data.error === 'string' ? data.error : data.error?.message) || error.message || '');
        const searchable = `${code} ${rawMessage}`.toLowerCase();

        if (!error.response || ['network', 'socket', 'connection', 'failed host lookup', 'timed out', 'timeout'].some((text) => searchable.includes(text))) {
            return ui('networkError');
        }
        if (code === 'TOO_MANY_SMS' || searchable.includes('too_many_sms') || searchable.includes('too many messages')) return ui('tooManySms');
        if (code === 'PASSWORD_LOGIN_LOCKED' || searchable.includes('password_login_locked') || searchable.includes('too many incorrect password')) return ui('passwordLoginLocked');
        if (code === 'INVALID_PASSWORD' || searchable.includes('invalid_password') || searchable.includes('invalid password')) {
            const remainingFromMessage = rawMessage.match(/(\d+)\s+attempts?\s+remaining/i)?.[1];
            const remaining = Number(data.remainingAttempts ?? remainingFromMessage);
            return Number.isFinite(remaining)
                ? ui('incorrectPasswordAttempts').replace('{count}', remaining)
                : ui('incorrectPassword');
        }
        if (code === 'MEMBER_NOT_FOUND' || searchable.includes('member_not_found') || searchable.includes('member not found')) return ui('memberNotFound');
        if (['INVALID_CODE', 'CODE_EXPIRED', 'TOO_MANY_ATTEMPTS', 'VERIFICATION_REQUIRED'].includes(code)
            || searchable.includes('invalid verification code')
            || searchable.includes('verification code expired')
            || searchable.includes('failed to verify code')) return ui('codeInvalidOrExpired');
        if (searchable.includes('already registered') || searchable.includes('already exists')) return ui('phoneAlreadyRegistered');
        if (searchable.includes('invalid email')) return ui('invalidEmail');
        if (searchable.includes('store') || searchable.includes('head office') || searchable.includes('request failed')) return ui('serviceUnavailable');
        return ui(fallbackKey);
    };

    const sendCrmCode = async () => {
        if (crmSmsCountdown > 0 || crmSmsRequestRef.current) return;
        if (!crmAuthForm.phone.trim()) {
            message.error(ui('enterMobileFirst'));
            return;
        }
        if (!isValidCrmMobile(crmAuthForm.phone)) {
            message.error(ui('invalidMobile'));
            return;
        }
        crmSmsRequestRef.current = true;
        setCrmSmsLoading(true);
        try {
            await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/crm-member/verification/send-code`, {
                restaurantUrl,
                phone: crmAuthForm.phone.trim(),
            }, { withCredentials: true });
            startCrmSmsCountdown();
            message.success(ui('verificationCodeSent'));
        } catch (error) {
            message.error(getCrmAuthError(error, 'sendCodeFailed'));
        } finally {
            crmSmsRequestRef.current = false;
            setCrmSmsLoading(false);
        }
    };

    const submitCrmAuth = async (mode = crmAuthMode) => {
        if (!isValidCrmMobile(crmAuthForm.phone)) {
            message.error(ui('invalidMobile'));
            return;
        }
        if (mode === 'register' && !crmTermsAccepted) {
            message.error(ui('agreeToPolicies'));
            return;
        }
        if ((mode === 'code' || mode === 'register') && !/^\d{6}$/.test(crmAuthForm.code.trim())) {
            message.error(ui('invalidCode'));
            return;
        }
        if (mode === 'password' && crmAuthForm.password.length < 6) {
            message.error(ui('passwordTooShort'));
            return;
        }
        if (mode === 'register') {
            const email = crmAuthForm.email.trim();
            if (crmAuthForm.password.length < 6 || crmAuthForm.password.length > 16) {
                message.error(ui('passwordLength'));
                return;
            }
            if (crmAuthForm.password !== crmAuthForm.confirmPassword) {
                message.error(ui('passwordMismatch'));
                return;
            }
            if (!crmAuthForm.firstName.trim() || !crmAuthForm.lastName.trim()) {
                message.error(ui('nameRequired'));
                return;
            }
            if (!crmAuthForm.ageGroup) {
                message.error(ui('ageGroupRequired'));
                return;
            }
            if ((crmEmailRequired && !email) || (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
                message.error(ui('invalidEmail'));
                return;
            }
        }
        const endpoint = mode === 'register'
            ? '/api/crm-member/register'
            : mode === 'code'
                ? '/api/crm-member/login/code'
                : '/api/crm-member/login/password';
        const payload = { restaurantUrl, phone: crmAuthForm.phone.trim() };
        if (mode === 'password') payload.password = crmAuthForm.password;
        if (mode === 'code') payload.code = crmAuthForm.code.trim();
        if (mode === 'register') Object.assign(payload, {
            password: crmAuthForm.password,
            code: crmAuthForm.code.trim(),
            firstName: crmAuthForm.firstName.trim(),
            middleName: crmAuthForm.middleName.trim() || null,
            lastName: crmAuthForm.lastName.trim(),
            email: crmAuthForm.email.trim() || null,
            birthday: crmAuthForm.birthday || null,
            ageGroup: crmAuthForm.ageGroup,
        });
        setCrmAuthLoading(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}${endpoint}`, payload, { withCredentials: true });
            applyCrmMember(response.data.member);
            setCrmAuthVisible(false);
            setRedeemPoints(0);
            message.success(`Welcome${response.data.member?.customerName ? `, ${response.data.member.customerName}` : ''}.`);
        } catch (error) {
            const errorCode = String(error.response?.data?.code || error.response?.data?.error || '').toUpperCase();
            if (mode === 'code'
                && errorCode === 'MEMBER_PROFILE_REQUIRED'
                && error.response?.data?.registrationToken) {
                setCrmRegistrationToken(error.response.data.registrationToken);
                setCrmAuthForm((current) => ({
                    ...current,
                    firstName: '', middleName: '', lastName: '', email: '', birthday: '',
                }));
                setCrmAuthVisible(false);
                setCrmProfileCompletionVisible(true);
                return;
            }
            if (mode === 'password' && errorCode === 'PASSWORD_LOGIN_LOCKED') setCrmAuthMode('code');
            message.error(getCrmAuthError(error));
        } finally {
            setCrmAuthLoading(false);
        }
    };

    const submitCrmProfileCompletion = async () => {
        const firstName = crmAuthForm.firstName.trim();
        const middleName = crmAuthForm.middleName.trim();
        const lastName = crmAuthForm.lastName.trim();
        const email = crmAuthForm.email.trim();
        if (!firstName || !lastName) {
            message.error(ui('nameRequired'));
            return;
        }
        if (email && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length > 30)) {
            message.error(ui('invalidEmail'));
            return;
        }
        if (!crmRegistrationToken) {
            message.error(ui('registrationExpired'));
            setCrmProfileCompletionVisible(false);
            return;
        }

        setCrmAuthLoading(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/api/crm-member/register/complete-code`,
                {
                    restaurantUrl,
                    registrationToken: crmRegistrationToken,
                    firstName,
                    middleName,
                    lastName,
                    email: email || null,
                    birthday: crmAuthForm.birthday || null,
                },
                { withCredentials: true }
            );
            applyCrmMember(response.data.member);
            setCrmProfileCompletionVisible(false);
            setCrmRegistrationToken('');
            setRedeemPoints(0);
            message.success(ui('registrationComplete'));
        } catch (error) {
            const errorCode = String(error.response?.data?.code || '').toUpperCase();
            if (errorCode === 'REGISTRATION_TOKEN_EXPIRED') {
                setCrmProfileCompletionVisible(false);
                setCrmRegistrationToken('');
                message.error(ui('registrationExpired'));
            } else {
                message.error(getCrmAuthError(error, 'registrationFailed'));
            }
        } finally {
            setCrmAuthLoading(false);
        }
    };

    const submitInlineCrmLogin = () => {
        if (!crmTermsAccepted) {
            message.error(ui('agreeToPolicies'));
            return;
        }
        if (!crmAuthForm.phone.trim() || !crmAuthForm.code.trim()) {
            message.error(ui('enterPhoneAndCode'));
            return;
        }
        submitCrmAuth('code');
    };

    const openCrmRegistration = () => {
        setCrmAuthMode('register');
        openCrmAuth();
    };

    const logoutCrmMember = async () => {
        await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/crm-member/logout`, {}, { withCredentials: true })
            .catch(() => undefined);
        applyCrmMember(null);
        setRedeemPoints(0);
        setCrmPointQuote(null);
    };

    const crmMemberId = crmMember?.customerId;
    const crmMemberRewardsEnabled = Number(crmMember?.rewardEnabled) === 1;

    useEffect(() => {
        if (!crmPointsConfig?.effectiveEnabled || !crmMemberId || !crmMemberRewardsEnabled || serviceType !== 1) {
            setCrmPointQuote(null);
            return undefined;
        }
        const timer = setTimeout(async () => {
            try {
                const eligibleAmountCents = Math.max(0, Math.round((Number(totalAmount || 0) - Number(promotionDiscount || 0)) * 100));
                const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/crm-member/points/quote`, {
                    restaurantUrl,
                    eligibleAmountCents,
                    surchargeRate: Number(surcharges || 0),
                    fixedAmountCents: Math.max(0, Math.round(getDeliveryFee() * 100)),
                    redeemPoints: Math.max(0, Math.floor(Number(redeemPoints || 0))),
                }, { withCredentials: true });
                setCrmPointQuote(response.data.quote);
                if (Number(response.data.quote.redeemPoints) !== Math.max(0, Math.floor(Number(redeemPoints || 0)))) {
                    setRedeemPoints(Number(response.data.quote.redeemPoints));
                }
            } catch (error) {
                setCrmPointQuote(null);
                if (error.response?.status === 401) applyCrmMember(null);
            }
        }, 250);
        return () => clearTimeout(timer);
    }, [crmPointsConfig?.effectiveEnabled, crmMemberId, crmMemberRewardsEnabled, serviceType, redeemPoints, totalAmount, promotionDiscount, restaurantUrl, surcharges, deliveryQuote, orderServiceMode]);

    const showDeliveryMinimumError = () => {
        const minimum = Number(deliveryMinimumOrderAmount || 0).toFixed(2);
        message.error({
            content: (ui('deliveryMinimumNotMet') || 'Delivery order amount is below the minimum of ${amount}.').replace('{amount}', minimum),
            style: { marginTop: '80px' },
        });
    };

    const handleDeliveryMinimumResponseError = (error) => {
        const serverMessage = typeof error.response?.data === 'string' ? error.response.data : error.response?.data?.message;
        if (error.response?.status === 400 && serverMessage?.includes('below the minimum')) {
            message.error({
                content: serverMessage,
                style: { marginTop: '80px' },
            });
            return true;
        }
        return false;
    };

    const getDeliveryInfoPayload = () => (
        orderServiceMode === 'Delivery'
            ? {
                address: userInfo.address,
                placeId: deliveryAddressPlaceId,
                deliveryFee: deliveryQuote?.deliveryFee || 0,
                distanceKm: deliveryQuote?.distanceKm || null,
            }
            : null
    );

    const validateOrderDetails = () => {
        if (!cartReady) return false;
        const effectiveServiceMode = serviceMode === 'Take-away' && deliveryEnabled ? orderServiceMode : serviceMode;

        if (serviceMode === 'Take-away' && deliveryEnabled && !orderServiceMode) {
            message.error(ui('pleaseSelectOrderType'));
            return false;
        }
        if ((effectiveServiceMode === 'Take-away' || effectiveServiceMode === 'Delivery') && !isSelectedServiceTimeAvailable(effectiveServiceMode)) {
            message.error(`${effectiveServiceMode} is not available at the selected time.`);
            return false;
        }

        if (effectiveServiceMode === 'Dine-in' && requireDineInGuestCount && !dineInGuestCount) {
            message.error(ui('pleaseSelectGuestCount'));
            navigate(`/qr_order/${restaurantUrl}/${tableNumber}`);
            return false;
        }

        if (effectiveServiceMode === 'Delivery') {
            if (deliveryMinimumOrderAmount > 0 && getOrderBaseAmount() < deliveryMinimumOrderAmount) {
                showDeliveryMinimumError();
                return false;
            }
            if (!userInfo.name || !userInfo.contactNumber || !userInfo.address) {
                message.error(ui('pleaseEnterInfo'));
                return false;
            }
            if (!deliveryQuote || deliveryQuoteLoading) {
                message.error(ui('pleaseSelectDeliveryAddress'));
                return false;
            }
        } else if ((!userInfo.name || !userInfo.contactNumber) && effectiveServiceMode === 'Take-away' && needCustomerInfo === 1) {
            message.error(ui('pleaseEnterInfo'));
            return false;
        }

        return true;
    };

    const calculateDeliveryFee = async ({ address, placeId }) => {
        if (!address || !storeId) {
            return;
        }
        if (orderServiceMode === 'Delivery' && !placeId) {
            setDeliveryQuote(null);
            setDeliveryQuoteError(ui('pleaseSelectDeliveryAddress'));
            return;
        }

        try {
            setDeliveryQuoteLoading(true);
            setDeliveryQuoteError('');
            const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/calculate-delivery-fee`, {
                storeId,
                destinationAddress: address,
                destinationPlaceId: placeId,
            });

            if (response.status === 200) {
                setDeliveryQuote({
                    distanceKm: response.data.distanceKm,
                    deliveryFee: response.data.deliveryFee,
                });
            }
        } catch (error) {
            console.error('Delivery quote error:', error);
            setDeliveryQuote(null);
            const serverMessage = error.response?.data?.message || '';
            if (serverMessage.includes('outside our delivery range')) {
                setUserInfo((prev) => ({ ...prev, address: '' }));
                setDeliveryAddressPlaceId('');
                setDeliveryQuoteError(ui('deliveryOutOfRange'));
            } else {
                setDeliveryQuoteError(serverMessage || ui('pleaseSelectDeliveryAddress'));
            }
        } finally {
            setDeliveryQuoteLoading(false);
        }
    };

    const loadGoogleMapsScript = () => new Promise((resolve, reject) => {
        if (window.google?.maps?.places) {
            resolve();
            return;
        }

        const existingScript = document.getElementById('google-maps-places-script');
        if (existingScript) {
            existingScript.addEventListener('load', resolve, { once: true });
            existingScript.addEventListener('error', reject, { once: true });
            return;
        }

        const googleKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || process.env.REACT_APP_GOOGLE_API_KEY;
        if (!googleKey) {
            reject(new Error('Google Maps API key is not configured'));
            return;
        }

        const script = document.createElement('script');
        script.id = 'google-maps-places-script';
        script.src = `https://maps.googleapis.com/maps/api/js?key=${googleKey}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });

    useEffect(() => {
        if (serviceMode !== 'Take-away') {
            setOrderServiceMode(serviceMode);
            return;
        }

        if (!deliveryEnabled) {
            setOrderServiceMode('Take-away');
        }
    }, [serviceMode, deliveryEnabled]);

    useEffect(() => {
        const timer = setInterval(() => setAvailabilityTick((value) => value + 1), 60000);
        return () => clearInterval(timer);
    }, []);

    const isCurrentServiceAvailable = (mode) => isServiceAvailable(storeHoursConfig, mode, new Date());

    const isSelectedServiceTimeAvailable = (mode) => {
        const date = new Date();
        if (!scheduleInfo.asap && scheduleInfo.time) {
            date.setHours(scheduleInfo.time.hour(), scheduleInfo.time.minute(), 0, 0);
        }
        return isServiceAvailable(storeHoursConfig, mode, date);
    };

    const takeawayAvailable = serviceMode !== 'Take-away' || isCurrentServiceAvailable('Take-away');
    const deliveryAvailable = serviceMode === 'Take-away' && deliveryEnabled && isCurrentServiceAvailable('Delivery');

    useEffect(() => {
        if (serviceMode !== 'Take-away' || !storeHoursConfig) return;
        if (deliveryEnabled) {
            if (takeawayAvailable && !deliveryAvailable) setOrderServiceMode('Take-away');
            else if (!takeawayAvailable && deliveryAvailable) setOrderServiceMode('Delivery');
            else if (!takeawayAvailable && !deliveryAvailable) setOrderServiceMode('');
            else if (orderServiceMode && !isCurrentServiceAvailable(orderServiceMode)) setOrderServiceMode('');
        } else {
            setOrderServiceMode('Take-away');
        }
    }, [serviceMode, deliveryEnabled, storeHoursConfig, availabilityTick]);

    useEffect(() => {
        if (!isUserInfoModalVisible || orderServiceMode !== 'Delivery') {
            return;
        }

        let cancelled = false;
        loadGoogleMapsScript()
            .then(() => {
                const input = deliveryAddressInputRef.current?.input
                    || deliveryAddressInputRef.current?.nativeElement?.querySelector?.('input')
                    || document.getElementById('delivery-address-input');
                if (cancelled || !input || !window.google?.maps?.places) {
                    return;
                }

                if (autocompleteRef.current) {
                    window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
                }

                autocompleteRef.current = new window.google.maps.places.Autocomplete(input, {
                    fields: ['formatted_address', 'place_id'],
                    types: ['address'],
                    componentRestrictions: { country: 'au' },
                });

                autocompleteRef.current.addListener('place_changed', () => {
                    const place = autocompleteRef.current.getPlace();
                    const address = place.formatted_address || input.value;
                    const placeId = place.place_id || '';
                    setDeliveryQuoteError('');
                    setDeliveryAddressPlaceId(placeId);
                    setUserInfo((prev) => ({ ...prev, address }));
                    calculateDeliveryFee({ address, placeId });
                });
            })
            .catch((error) => {
                console.error('Google Places load error:', error);
                message.error('Google address autocomplete is not available.');
            });

        return () => {
            cancelled = true;
        };
    }, [isUserInfoModalVisible, orderServiceMode, storeId]);

    // 更新handleLoadingComplete函数
    const handleLoadingComplete = () => {
        // 调用当前保存在ref中的回调函数
        loadingCompleteCallbackRef.current();
    };

    useEffect(() => {
        if (orderId) {
            checkOrderStatus(orderId);
        }
    }, [orderId]);

    const checkOrderStatus = async (orderId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/cancel-order/${orderId}`);

            if (response.status === 200) {
                console.log('Order is cancelled');
                setStoreId(response.data.restaurant.StoreId);

                setStoreName(response.data.restaurant.StoreName);
                setStoreAddress(response.data.restaurant.StoreAddress);
                setStorePhone(response.data.restaurant.StorePhone);
                setStoreImg(response.data.restaurant.StoreImgPath);
                // setStoreTimetable(response.data.restaurant.StoreTimetable);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const checkTable = async (tableNumber) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/check-table/${restaurantUrl}/${tableNumber}`);
            if (response.status === 200) {
                console.log('Table is available');
                return true;
            }
            else {
                console.log('Table is not available');
                return false;
            }
        } catch (error) {
            console.error(error);
            return false;
        }
    };

    const cancelTyroOrder = async (orderId) => {
        try {
            if (!orderId) {
                console.log('No orderId provided for cancellation');
                return;
            }
            const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/cancel-tyro-order`, {
                orderId: orderId
            });
            
            if (response.status === 200) {
                console.log('Tyro order cancelled:', response.data);
            }
        } catch (error) {
            console.error('Error cancelling Tyro order:', error);
        }
    };

    // 更新 handlePayment 和 saveOrder 函数，添加对用户信息的验证
    const handlePayment = async (totalAmount) => {
        try {
            if (isOrdering) return; // 如果已经在下单中，则不再执行
           
            if (!validateOrderDetails()) {
                return;
            }
            const effectiveServiceMode = serviceMode === 'Take-away' && deliveryEnabled ? orderServiceMode : serviceMode;
            const deliveryInfo = getDeliveryInfoPayload();
            const pickupTime = scheduleInfo.asap ? null : scheduleInfo.time.format('HH:mm');

            const cooldownAvailable = await ensureMenuItemCooldownAvailable(effectiveServiceMode);
            if (!cooldownAvailable) {
                return;
            }

            setIsOrdering(true);
            // 直接处理支付，不显示进度条
            
            if (serviceMode === 'Dine-in') {
                const tableValid = await checkTable(tableNumber);
                if (tableValid) {
                    if (PaymentGateway === 'Stripe') {
                        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/create-checkout-session`, {
                            amount: totalAmount,
                            shopUrl: restaurantUrl,
                            storeId: storeId,
                            cart: cart,
                            serviceMode: effectiveServiceMode,
                            tableNumber: tableNumber,
                            totalGST: totalGST,
                            surcharge: surcharges,
                            notes: note,
                            userInfo: userInfo,
                            scheduleInfo: pickupTime,
                            promotionTitle: promotionEnabled ? promotionTitle : null,
                            promotionAmount: promotionEnabled ? promotionDiscount : null,
                            deliveryInfo: deliveryInfo,
                            guestCount: effectiveServiceMode === 'Dine-in' ? dineInGuestCount : null,
                            redeemPoints: Math.max(0, Math.floor(Number(redeemPoints || 0))),
                            
                        }, { withCredentials: true });
                        if (response.status === 200) {
                            rememberSubmittedMenuItemCooldowns(effectiveServiceMode);
                            localStorage.setItem('hasVisitedPayment', 'true');
                            // 直接跳转到支付页面
                            window.location.href = response.data.url;
                        }
                        else {
                            console.log(response.data.error);
                            alert("Service is not available at the moment. Please contact the staff for assistance.");
                        }
                    }
                    else if (PaymentGateway === 'Tyro'){
                        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/create-tyro-checkout-session`, {
                            amount: totalAmount,
                            shopUrl: restaurantUrl,
                            storeId: storeId,
                            cart: cart,
                            serviceMode: effectiveServiceMode,
                            tableNumber: tableNumber,
                            totalGST: totalGST,
                            surcharge: surcharges,
                            notes: note,
                            userInfo: userInfo,
                            scheduleInfo: pickupTime,
                            promotionTitle: promotionEnabled ? promotionTitle : null,
                            promotionAmount: promotionEnabled ? promotionDiscount : null,
                            deliveryInfo: deliveryInfo,
                            guestCount: effectiveServiceMode === 'Dine-in' ? dineInGuestCount : null,
                            redeemPoints: Math.max(0, Math.floor(Number(redeemPoints || 0))),
                        }, { withCredentials: true });
                      
                        if (response.status === 200) {
                            rememberSubmittedMenuItemCooldowns(effectiveServiceMode);
                            setPaySecret(response.data.paySecret);
                            setTyroOrderAmount(response.data.totalAmountInCents);
                            setTyroOrderId(response.data.orderId);
                            setIsTyroModalVisible(true);
                        }
                        else {
                            alert("Service is not available at the moment. Please contact the staff for assistance.");
                        }
                    }
                }
                else {
                    alert("Table is not available");
                }

            }
            else {
                if (PaymentGateway === 'Stripe') {
                    const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/create-checkout-session`, {
                        amount: totalAmount,
                        shopUrl: restaurantUrl,
                        storeId: storeId,
                        cart: cart,
                        serviceMode: effectiveServiceMode,
                        tableNumber: tableNumber,
                        totalGST: totalGST,
                        surcharge: surcharges,
                        notes: note,
                        userInfo: userInfo,
                        scheduleInfo: pickupTime,
                        promotionTitle: promotionEnabled ? promotionTitle : null,
                        promotionAmount: promotionEnabled ? promotionDiscount : null,
                        deliveryInfo: deliveryInfo,
                        guestCount: effectiveServiceMode === 'Dine-in' ? dineInGuestCount : null,
                        redeemPoints: Math.max(0, Math.floor(Number(redeemPoints || 0))),
                    }, { withCredentials: true });
                    if (response.status === 200) {
                        rememberSubmittedMenuItemCooldowns(effectiveServiceMode);
                        localStorage.setItem('hasVisitedPayment', 'true');
                        // 直接跳转到支付页面
                        window.location.href = response.data.url;
                    }
                    else {
                        alert("Service is not available at the moment. Please contact the staff for assistance.");
                    }
                }
                else if (PaymentGateway === 'Tyro'){
                    const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/create-tyro-checkout-session`, {
                        amount: totalAmount,
                        shopUrl: restaurantUrl,
                        storeId: storeId,
                        cart: cart,
                        serviceMode: effectiveServiceMode,
                        tableNumber: tableNumber,
                        totalGST: totalGST,
                        surcharge: surcharges,
                        notes: note,
                        userInfo: userInfo,
                        scheduleInfo: pickupTime,
                        promotionTitle: promotionEnabled ? promotionTitle : null,
                        promotionAmount: promotionEnabled ? promotionDiscount : null,
                        deliveryInfo: deliveryInfo,
                        guestCount: effectiveServiceMode === 'Dine-in' ? dineInGuestCount : null,
                        redeemPoints: Math.max(0, Math.floor(Number(redeemPoints || 0))),
                    }, { withCredentials: true });
                    if (response.status === 200) {
                        rememberSubmittedMenuItemCooldowns(effectiveServiceMode);
                        const receivedPaySecret = response.data.paySecret;
                        setPaySecret(receivedPaySecret);
                        setTyroOrderId(response.data.orderId);
                        setIsTyroModalVisible(true);
                    }
                    else {
                        alert("Service is not available at the moment. Please contact the staff for assistance.");
                    }
                }
            }

        } catch (error) {
            console.error('Payment error:', error);
            if (handleDeliveryMinimumResponseError(error)) {
                setIsOrdering(false);
                return;
            }
            if (isMenuItemConflictError(error)) {
                handleCooldownError(error);
                setIsOrdering(false);
                return;
            }
            alert("Service is not available at the moment. Please contact the staff for assistance.");
            setIsOrdering(false);
            // 处理错误情况
        }
    };

    const handlePaymentSuccess = (payRequest) => {
        message.success('Payment successful!');
        console.log('Tyro Payment Success:', payRequest);
        navigate(`/qr_order/${restaurantUrl}/order-success/${payRequest.origin.orderId}?from=payment`);
        // Handle post-payment success logic here, e.g., navigate to a success page
        setIsTyroModalVisible(false);
        setPaySecret(null);
        setIsOrdering(false); // Reset ordering state after successful payment
      };
    
      const handlePaymentError = async (error) => {
        message.error('Payment failed. Please try again.');
        console.error('Tyro Payment Error:', error);
        
        // 取消并删除订单
        if (tyroOrderId) {
            await cancelTyroOrder(tyroOrderId);
        }
        
        setIsTyroModalVisible(false);
        setPaySecret(null);
        setTyroOrderId(null);
        setIsOrdering(false); // Reset ordering state after payment error
      };

    const saveOrder = async (totalAmount) => {
        try {
            if (isOrdering) return; // 如果已经在下单中，则不再执行

            if (!validateOrderDetails()) {
                return;
            }
            const effectiveServiceMode = serviceMode === 'Take-away' && deliveryEnabled ? orderServiceMode : serviceMode;
            const deliveryInfo = getDeliveryInfoPayload();

            const cooldownAvailable = await ensureMenuItemCooldownAvailable(effectiveServiceMode);
            if (!cooldownAvailable) {
                return;
            }

            setIsOrdering(true);
            setIsLoading(true); // 显示加载进度条
            setLoadingText(ui('sendingOrder')); // 设置加载文本
            
            const pickupTime = scheduleInfo.asap ? null : scheduleInfo.time.format('HH:mm');
              
            try {
                // 如果是堂食，需要验证餐桌号
                if (serviceMode === 'Dine-in') {
                    const tableValid = await checkTable(tableNumber);
                    if (!tableValid) {
                        setIsLoading(false);
                        setIsOrdering(false);
                        alert("Table is not available");
                        return;
                    }
                }
                
                // Another phone may submit while table/cooldown checks are pending.
                if (JSON.stringify(cart) !== JSON.stringify(latestCart.current)) {
                    setIsLoading(false);
                    setIsOrdering(false);
                    return;
                }

                // 发送订单请求 - 这里会等待后端的Promise解析
                // 根据服务器端代码，后端会创建一个Promise并等待confirmOrder API调用来解析它
                // 如果15秒内没有收到确认，后端会发送500错误响应
                const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/save-order`, {
                    amount: totalAmount,
                    shopUrl: restaurantUrl,
                    storeId: storeId,
                    cart: cart,
                    serviceMode: effectiveServiceMode,
                    tableNumber: tableNumber,
                    totalGST: totalGST,
                    surcharge: surcharges,
                    notes: note,
                    userInfo: userInfo,
                    scheduleInfo: pickupTime,
                    promotionTitle: promotionEnabled ? promotionTitle : null,
                    promotionAmount: promotionEnabled ? promotionDiscount : null,
                    deliveryInfo: deliveryInfo,
                    guestCount: effectiveServiceMode === 'Dine-in' ? dineInGuestCount : null,
                }, { withCredentials: true });
                
                if (response.status === 200) {
                    rememberSubmittedMenuItemCooldowns(effectiveServiceMode);
                    console.log('Order confirmed:', response.data);
                    setCartFromRemote([]);
                    const orderId = response.data.orderId;
                    
                    // 订单已确认，设置loadingCompleteCallback来结束进度条并导航
                    loadingCompleteCallbackRef.current = () => {
                        setIsLoading(false);
                        navigate(`/qr_order/${restaurantUrl}/order-success/${orderId}`, { replace: true });
                    };
                    
                    // 触发进度条完成
                    handleLoadingComplete();
                } else {
                    // 处理非200响应
                    setIsLoading(false);
                    setIsOrdering(false);
                    alert("Service is not available at the moment. Please contact the staff for assistance.");
                }
            } catch (error) {
                // 错误处理
                console.error('Error saving order:', error);
                setIsLoading(false);
                setIsOrdering(false);
                
                if (handleDeliveryMinimumResponseError(error)) {
                    return;
                }
                if (isMenuItemConflictError(error)) {
                    handleCooldownError(error);
                    return;
                }
                // 检查是否是超时错误
                if (error.response && error.response.status === 500) {
                    message.error('Order confirmation timed out. Please try again or contact staff.');
                } else {
                    alert("Service is not available at the moment. Please contact the staff for assistance.");
                }
            }
        } catch (error) {
            setIsLoading(false);
            setIsOrdering(false);
            console.error('Error in saveOrder:', error);
            alert("Service is not available at the moment. Please contact the staff for assistance.");
        }
    }

    useEffect(() => {
        // 定义一个内部的异步函数
        const fetchStoreConfig = async () => {

            try {
                const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/fetchStoreConfig/${restaurantUrl}`, { tableNumber: tableNumber });
                if (response.status === 200) {
                    setServiceType(response.data.storeConfig.PayFirst);
                    setEnableSharedCart(response.data.storeConfig.EnableSharedCart !== 0);
                    setPaymentGateway(response.data.storeConfig.PaymentGateway);
                    setStoreName(response.data.storeInformation.StoreName);
                    setStoreId(response.data.storeInformation.StoreId);
                    setStoreAddress(response.data.storeInformation.StoreAddress);
                    setStorePhone(response.data.storeInformation.StorePhone);
                    setFirstLanguage(response.data.storeConfig.FirstLanguage);
                    setSecondLanguage(response.data.storeConfig.SecondLanguage);
                    setNeedCustomerInfo(response.data.storeConfig.NeedCustomerInfo);
                    setRequireDineInGuestCount(response.data.storeConfig.RequireDineInGuestCount !== 0);
                    const isDeliveryEnabled = response.data.storeConfig.EnableDeliveryFunction === 1;
                    setDeliveryEnabled(isDeliveryEnabled);
                    setDeliveryMinimumOrderAmount(Number(response.data.storeConfig.DeliveryMinimumOrderAmount || 0));
                    if (serviceMode === 'Take-away') {
                        setOrderServiceMode(isDeliveryEnabled ? '' : 'Take-away');
                    } else {
                        setOrderServiceMode(serviceMode);
                    }
                    
                    // Set promotion data
                    setPromotionEnabled(response.data.storeConfig.PromotionEnable === 1);
                    setPromotionTitle(response.data.storeConfig.PromotionTitle || '');
                    setPromotionType(response.data.storeConfig.PromotionType || '');
                    setPromotionValue(response.data.storeConfig.PromotionValue || 0);
                    setPromotionMinAmount(response.data.storeConfig.PromotionMinAmount || 0);
                    const crmConfig = response.data.crmPoints || null;
                    setCrmPointsConfig(crmConfig);
                    if (crmConfig?.effectiveEnabled) {
                        await loadCrmMember();
                    } else {
                        applyCrmMember(null);
                    }
                    
                    // Set Customer Menu Show Price
                    setShowPriceInCustomerMenu(response.data.storeConfig.ShowPriceInCustomerMenu !== 0);

                    console.log(response.data.storeConfig.PaymentGateway);
                    if (response.data.storeConfig.PayFirst===1){
                        setStyleColor("#ffda62");
                    }
                    else{
                        setStyleColor("#ffda62");
                    }
                  
                 
                    const today = new Date();
                    const dayOfWeek = today.getDay();

                    const state = response.data.storeInformation.Location;

                    let surcharges;
                  
                    const isHoliday = await checkPublicHoliday(today, state);


                    if  (isHoliday) {

                        surcharges = response.data.storeConfig.PublicSurcharge;
                        setSurchargeDescription("Public Holiday Surcharge");
                        setSurcharges(surcharges);
                    }
                    else if(dayOfWeek === 0 || dayOfWeek === 6) {
                        if (response.data.storeConfig.WeekendSurcharge > 0) {
                            surcharges = response.data.storeConfig.WeekendSurcharge;
                            setSurchargeDescription("Weekend Surcharge");
                            setSurcharges(surcharges);
                        }
                        else{
                            surcharges = response.data.storeConfig.Surcharge;
                            setSurcharges(surcharges);
                            setSurchargeDescription(response.data.storeConfig.SurchargeDescription);
                        }
                    }
                    else {

                        surcharges = response.data.storeConfig.Surcharge;
                        setSurcharges(surcharges);
                        setSurchargeDescription(response.data.storeConfig.SurchargeDescription);

                    }

                    setLoading(false); // 设置加载完成

                    const {
                        MondayStart, MondayEnd, MondayBreakStart, MondayBreakEnd,
                        TuesdayStart, TuesdayEnd, TuesdayBreakStart, TuesdayBreakEnd,
                        WednesdayStart, WednesdayEnd, WednesdayBreakStart, WednesdayBreakEnd,
                        ThursdayStart, ThursdayEnd, ThursdayBreakStart, ThursdayBreakEnd,
                        FridayStart, FridayEnd, FridayBreakStart, FridayBreakEnd,
                        SaturdayStart, SaturdayEnd, SaturdayBreakStart, SaturdayBreakEnd,
                        SundayStart, SundayEnd, SundayBreakStart, SundayBreakEnd,
                    } = response.data.storeConfig;
                    setStoreHoursConfig(response.data.storeConfig);
                    setStoreTimetable({
                        Monday: { start: MondayStart, end: MondayEnd, breakStart: MondayBreakStart, breakEnd: MondayBreakEnd },
                        Tuesday: { start: TuesdayStart, end: TuesdayEnd, breakStart: TuesdayBreakStart, breakEnd: TuesdayBreakEnd },
                        Wednesday: { start: WednesdayStart, end: WednesdayEnd, breakStart: WednesdayBreakStart, breakEnd: WednesdayBreakEnd },
                        Thursday: { start: ThursdayStart, end: ThursdayEnd, breakStart: ThursdayBreakStart, breakEnd: ThursdayBreakEnd },
                        Friday: { start: FridayStart, end: FridayEnd, breakStart: FridayBreakStart, breakEnd: FridayBreakEnd },
                        Saturday: { start: SaturdayStart, end: SaturdayEnd, breakStart: SaturdayBreakStart, breakEnd: SaturdayBreakEnd },
                        Sunday: { start: SundayStart, end: SundayEnd, breakStart: SundayBreakStart, breakEnd: SundayBreakEnd }
                    });


                }
            } catch (error) {
                console.error(error);
                setLoading(false); // 设置加载完成
            }
        };

        // 调用内部定义的异步函数
        fetchStoreConfig();
    }, [restaurantUrl, tableNumber]); // 添加依赖项

    const checkPublicHoliday = async (today, state) => {
        // 获取当地日期字符串
        const dateString = today.toLocaleDateString('en-CA');
        let holidays;

        switch (state) {
            case 'Melbourne':
                holidays = [
                    '2024-11-05', '2024-12-25', '2024-12-26',
                    '2025-01-01', '2025-01-27', '2025-03-10', '2025-04-18', '2025-04-19', '2025-04-20',
                    '2025-04-21', '2025-04-25', '2025-06-09', '2025-09-26', '2025-11-04', '2025-12-25', '2025-12-26',
                    '2026-01-01', '2026-01-26', '2026-03-09', '2026-04-03', '2026-04-04', '2026-04-05',
                    '2026-04-06', '2026-04-25', '2026-06-08', '2026-09-25', '2026-11-03', '2026-12-25', '2026-12-26', '2026-12-28'
                ];
                break;
            case 'Sydney':
                holidays = [
                    '2024-12-25', '2024-12-26',
                    '2025-01-01', '2025-01-27', '2025-04-18', '2025-04-19', '2025-04-20', '2025-04-21',
                    '2025-04-25', '2025-06-09', '2025-10-06', '2025-12-25', '2025-12-26',
                    '2026-01-01', '2026-01-26', '2026-04-03', '2026-04-04', '2026-04-05', '2026-04-06',
                    '2026-04-25', '2026-06-08', '2026-10-05', '2026-12-25', '2026-12-26', '2026-12-28'
                ];
                break;
            case 'Brisbane':
                holidays = [
                    '2024-12-25', '2024-12-26',
                    '2025-01-01', '2025-01-27', '2025-04-18', '2025-04-19', '2025-04-20', '2025-04-21',
                    '2025-04-25', '2025-05-05', '2025-08-13', '2025-10-06', '2025-12-24', '2025-12-25', '2025-12-26',
                    '2026-01-01', '2026-01-26', '2026-04-03', '2026-04-04', '2026-04-05', '2026-04-06',
                    '2026-04-25', '2026-05-04', '2026-08-12', '2026-10-05', '2026-12-24', '2026-12-25', '2026-12-26', '2026-12-28'
                ];
                break;
            default:
                return false;
        }
        

        return holidays.includes(dateString);
    };

    const ClickOrderMoreButton = async () => {
        try {
            navigate(`/qr_order/${restaurantUrl}/${tableNumber}`, { state: { orderingMore: true } });
        } catch (error) {
            console.error(error);
        }
    }

    // 显示用户信息输入弹出框
    const showUserInfoModal = () => {
        setIsUserInfoModalVisible(true);
        //.fixed-bottom 的z-index设置为少的值
        if (document.querySelector('.fixed-bottom')){
            document.querySelector('.fixed-bottom').style.zIndex = 0;
        }
       
    };

    const handleUserInfoOk = () => {
        // 验证用户信息是否填写
        if (!userInfo.name || !userInfo.contactNumber) {
            message.error(ui('pleaseEnterInfo'));
            return;
        }
        if (orderServiceMode === 'Delivery' && (!userInfo.address || !deliveryQuote)) {
            message.error(ui('pleaseSelectDeliveryAddress'));
            return;
        }
        setIsUserInfoModalVisible(false);
    };

    const handleUserInfoCancel = () => {
        setIsUserInfoModalVisible(false);
    };

    // 显示取餐时间选择弹出框
    const showScheduleModal = () => {
        setIsScheduleModalVisible(true);
         //.fixed-bottom 的z-index设置为少的值
         if (document.querySelector('.fixed-bottom')){
            document.querySelector('.fixed-bottom').style.zIndex = 0;
        }


    };

    const handleScheduleOk = () => {
        if (!scheduleInfo.asap && !scheduleInfo.time) {
            message.error(ui('pickUpTime'));
            return;
        }
        const effectiveServiceMode = serviceMode === 'Take-away' && deliveryEnabled ? orderServiceMode : serviceMode;
        if (!isSelectedServiceTimeAvailable(effectiveServiceMode)) {
            message.error(`${effectiveServiceMode} is not available at the selected time.`);
            return;
        }
        setIsScheduleModalVisible(false);
    };

    const handleScheduleCancel = () => {
        setIsScheduleModalVisible(false);
    };
    const getCurrentDaySchedule = () => {
        const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const today = new Date();
        const currentDay = daysOfWeek[today.getDay()];
        return storeTimetable ? storeTimetable[currentDay] : null;
    };
    const showCrmMemberLogin = crmPointsConfig?.configuredEnabled === true
        && crmPointsConfig?.effectiveEnabled === true
        && crmPointsConfig?.activation?.active === true;
      

    return (
        <div className="container order-details-page" style={{ background: '#f1f1f1', minHeight: '100vh' }}>
            {loading ? (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <Spin size="large" style={{ color: 'orange' }} />
                </div>
            ) : (<>
                {isLoading && (
                    <LoadingOverlay 
                        loadingText={loadingText}
                        onComplete={handleLoadingComplete}
                    />
                )}
                <div className="header">
                    <div className="box">
                        <div className="left">
                            <div className="item">
                                <img src="/img/icon1.svg" id="btn3" onClick={toggleSidePopup} />
                            </div>
                            <div>
                                {storeName}</div>
                        </div>
                        <div className="right">
                            <div className="item">
                                <a onClick={ClickOrderMoreButton}>
                                    <img src="/img/icon6.svg" />
                                </a>
                            </div>

                        </div>
                    </div>
                </div>

                <header className="mui-bar mui-bar-transparent">
                    {/* /QROrder/:restaurantUrl/menu */}
                    <a className="mui-action-back zdy_bar_icon" onClick={ClickOrderMoreButton}>
                        <img src="/img/icon2.svg" />
                    </a>

                    <h1 className="mui-title">{ui('cartDetails')}</h1>
                </header>

                <div style={{ height: '44px' }}></div>
                <div className="container-fluid">
                    {showCrmMemberLogin && (
                        <section className="zdy_card2 crm-member-card" aria-label="Member rewards">
                            <div className="crm-member-card__header">
                                <span className="crm-member-card__avatar" aria-hidden="true">
                                    <img src={`${process.env.PUBLIC_URL}/img/crm-member-fork.webp`} alt="" />
                                </span>
                                {crmMember ? (
                                    <div className="crm-member-card__member-copy">
                                        <div className="crm-member-card__name-line">
                                            <strong>{crmMember.customerName || 'Member'}</strong>
                                            {crmMember.memberLevelName && (
                                                <span className="crm-member-card__vip">{crmMember.memberLevelName}</span>
                                            )}
                                        </div>
                                        <span>{ui('memberId')} · {crmMember.customerId || '—'}</span>
                                    </div>
                                ) : (
                                    <div className="crm-member-card__member-copy">
                                        <div className="crm-member-card__name-line">
                                            <strong>{ui('memberLogin')}</strong>
                                            <button type="button" onClick={openCrmRegistration}>{ui('joinForRewards')}</button>
                                        </div>
                                        <span>{ui('memberBenefits')}</span>
                                    </div>
                                )}
                                {crmMember && (
                                    <button type="button" className="crm-member-card__account" onClick={logoutCrmMember}>
                                        {ui('logout')} <span aria-hidden="true">›</span>
                                    </button>
                                )}
                            </div>

                            {crmMember ? (
                                <div className="crm-member-card__stats">
                                    <div>
                                        <span>{ui('currentPoints')}</span>
                                        <strong>{Number(crmMember.currentPoints || 0).toLocaleString()}</strong>
                                    </div>
                                    <div>
                                        <span>{ui('availableCoupons')}</span>
                                        <strong>0</strong>
                                    </div>
                                </div>
                            ) : (
                                <div className="crm-member-card__login-form">
                                    <label className="crm-member-card__field">
                                        <span className="crm-member-card__field-icon" aria-hidden="true">
                                            <svg viewBox="0 0 24 24"><rect x="7" y="3" width="10" height="18" rx="2" /><path d="M10 18h4" /></svg>
                                        </span>
                                        <Input
                                            bordered={false}
                                            placeholder={ui('mobileNumber')}
                                            inputMode="tel"
                                            maxLength={10}
                                            value={crmAuthForm.phone}
                                            onChange={(e) => setCrmAuthForm({ ...crmAuthForm, phone: e.target.value })}
                                        />
                                    </label>
                                    <label className="crm-member-card__field">
                                        <span className="crm-member-card__field-icon" aria-hidden="true">
                                            <svg viewBox="0 0 24 24"><path d="M12 3 19 6v5c0 4.5-2.8 8-7 10-4.2-2-7-5.5-7-10V6l7-3Z" /><path d="m9 12 2 2 4-4" /></svg>
                                        </span>
                                        <Input
                                            bordered={false}
                                            placeholder={ui('verificationCode')}
                                            inputMode="numeric"
                                            maxLength={6}
                                            value={crmAuthForm.code}
                                            onChange={(e) => setCrmAuthForm({ ...crmAuthForm, code: e.target.value.replace(/\D/g, '').slice(0, 6) })}
                                        />
                                        <button type="button" className="crm-member-card__send-code" disabled={crmSmsLoading || crmSmsCountdown > 0} onClick={sendCrmCode}>
                                            {crmSmsLoading ? ui('sending') : crmSmsCountdown > 0 ? `${crmSmsCountdown}s` : ui('getCode')}
                                        </button>
                                    </label>
                                    <div className="crm-member-card__agreement">
                                        <input
                                            id="crm-member-legal-agreement"
                                            type="checkbox"
                                            checked={crmTermsAccepted}
                                            onChange={(e) => setCrmTermsAccepted(e.target.checked)}
                                        />
                                        <label htmlFor="crm-member-legal-agreement">{ui('agreementPrefix')}</label>
                                        <button type="button" onClick={() => setCrmLegalDocument('terms')}>{ui('termsOfUse')}</button>
                                        <span>{uiLanguage === 'en' ? 'and' : '·'}</span>
                                        <button type="button" onClick={() => setCrmLegalDocument('privacy')}>{ui('privacyPolicy')}</button>
                                        <span>.</span>
                                    </div>
                                    <Button className="crm-member-card__submit" loading={crmAuthLoading} onClick={submitInlineCrmLogin}>
                                        {ui('loginRegister')}
                                    </Button>
                                </div>
                            )}

                            {crmMember && (
                                <>
                                    {serviceType === 1 && Number(crmMember.rewardEnabled) === 1 && (
                                        <div className="crm-member-card__redeem">
                                            <div className="crm-member-card__redeem-heading">
                                                <label htmlFor="crm-redeem-points">{ui('usePoints')}</label>
                                                <button
                                                    type="button"
                                                    onClick={() => setRedeemPoints(Number(crmPointQuote?.maxRedeemPoints ?? crmMember.currentPoints ?? 0))}
                                                >
                                                    {ui('useMaximum')}
                                                </button>
                                            </div>
                                            <InputNumber
                                                id="crm-redeem-points"
                                                min={0}
                                                max={Number(crmPointQuote?.maxRedeemPoints ?? crmMember.currentPoints ?? 0)}
                                                precision={0}
                                                value={redeemPoints}
                                                onChange={(value) => setRedeemPoints(Math.max(0, Math.floor(Number(value || 0))))}
                                                controls={false}
                                                style={{ width: '100%' }}
                                            />
                                            <small>
                                                {crmPointQuote
                                                    ? `Save $${(crmPointQuote.redeemAmountCents / 100).toFixed(2)} and collect about ${crmPointQuote.earnPoints} points from this order.`
                                                    : `${crmPointsConfig.redeemPointsPerDollar} ${ui('pointsDiscountRate')}`}
                                            </small>
                                        </div>
                                    )}
                                    {serviceType === 1 && Number(crmMember.rewardEnabled) !== 1 && (
                                        <div className="crm-member-card__notice">{ui('rewardsUnavailable')}</div>
                                    )}
                                </>
                            )}
                        </section>
                    )}

                    <div className="zdy_card2">
                        <div className="typeofservice">
                            <div className="cell">

                                <span style={{ fontWeight: 'bold' }}>
                                    {serviceMode === 'Dine-in' ? ui('dinein') : ui('orderType')}
                                </span>

                            </div>
                            {serviceMode === 'Dine-in' && (
                                <div className="cell">
                                    <span>{ui('tableNo')}</span>
                                    <b>{tableNumber}</b>
                                </div>
                            )}
                        </div>
                        {serviceMode === 'Take-away' && deliveryEnabled && (takeawayAvailable || deliveryAvailable) && (
                            <div className="delivery-mode-selector">
                                {takeawayAvailable && <button
                                    type="button"
                                    className={orderServiceMode === 'Take-away' ? 'active' : ''}
                                    onClick={() => {
                                        setOrderServiceMode('Take-away');
                                        setDeliveryQuote(null);
                                        setDeliveryQuoteError('');
                                    }}
                                >
                                    {ui('takeaway')}
                                </button>}
                                {deliveryAvailable && <button
                                    type="button"
                                    className={orderServiceMode === 'Delivery' ? 'active' : ''}
                                    onClick={() => {
                                        setOrderServiceMode('Delivery');
                                        setDeliveryQuote(null);
                                        setDeliveryQuoteError('');
                                    }}
                                >
                                    {ui('delivery')}
                                </button>}
                            </div>
                        )}
                        {serviceMode === 'Take-away' && !takeawayAvailable && !deliveryAvailable && (
                            <div className="service-unavailable">Takeaway and delivery are currently unavailable.</div>
                        )}
                        {serviceMode === 'Take-away' && (!deliveryEnabled || orderServiceMode) && (needCustomerInfo === 1 || deliveryEnabled) && (
                            <div className="takeaway-container">
                                <div className="takeaway-info-section" onClick={showUserInfoModal}>
                                    <span className="material-symbols-outlined takeaway-info">perm_contact_calendar</span>
                                    <div className="takeaway-content">
                                        {userInfo.name && userInfo.contactNumber ? (
                                            <>
                                                <h2 className="takeaway-title">{userInfo.name} {userInfo.contactNumber}</h2>
                                                {userInfo.address && <p className="takeaway-subtitle">{userInfo.address}</p>}
                                            </>
                                        ) : (
                                            <p className="takeaway-placeholder">{ui('enterYourInformation')}</p>
                                        )}
                                    </div>
                                    <svg className="takeaway-chevron" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                                <div className="takeaway-info-section" onClick={showScheduleModal}>
                                    <span className="material-symbols-outlined takeaway-info">schedule</span>
                                    <div className="takeaway-content">
                                        {scheduleInfo.asap ? (
                                            <h2 className="takeaway-title">{ui('asap')}</h2>
                                        ) : (
                                            <>
                                                <h2 className="takeaway-title">{ui('pickUpTime')}</h2>
                                                <p className="takeaway-subtitle">{scheduleInfo.time && scheduleInfo.time.format('HH:mm')}</p>
                                            </>
                                        )}
                                    </div>
                                    <svg className="takeaway-chevron" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                                {orderServiceMode === 'Delivery' && (deliveryQuote || deliveryQuoteLoading || deliveryQuoteError) && (
                                    <div className={`delivery-fee-summary ${deliveryQuoteError ? 'error' : ''}`}>
                                        {deliveryQuoteLoading ? (
                                            <span>{ui('calculatingDelivery')}</span>
                                        ) : deliveryQuoteError ? (
                                            <span>{deliveryQuoteError}</span>
                                        ) : (
                                            <>
                                                <div>
                                                    <span>{ui('estimatedDeliveryFee')}</span>
                                                    <b>${Number(deliveryQuote.deliveryFee).toFixed(2)}</b>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* 下面是订单详情的代码，保持不变 */}
                    <div className="zdy_card2">
                        <div className="title">
                            {/* <img src="/img/dish.svg"/> */}
                            <span>{ui('menuItems')}</span>
                        </div>
                        <ul>
                            {cart.map(([_, mainItem, ...extraItems]) => (
                                <React.Fragment key={mainItem.mainItemCode}>
                                    <li>
                                        <span style={{ fontWeight: "600", marginRight: "30px", marginBottom: "3px" }}>{mainItem.mainItemDescription} x {mainItem.quantity}</span>
                                        <span>{showPriceInCustomerMenu ? `$${(mainItem.quantity * mainItem.price).toFixed(2)}` : '\u00A0'}</span>
                                    </li>
                                    {extraItems.length === 0 && <li style={{ borderBottom: "1px solid #e6e6e6" }}></li>}
                                    {extraItems.map((extraItem, index) => (
                                        <li key={extraItem.itemCode}>
                                            <span style={{ paddingLeft: "14px", fontSize: "13px", marginTop: "-12px" }}> - {extraItem.itemDescription} x {extraItem.quantity}</span>
                                            <span style={{ fontSize: "13px", marginTop: "-12px" }}>{showPriceInCustomerMenu ? `$${(extraItem.quantity * extraItem.price).toFixed(2)}` : '\u00A0'}</span>
                                        </li>
                                    ))}
                                    {mainItem.spellInstruction && mainItem.spellInstruction.trim() !== "" && typeof mainItem.spellInstruction !== "undefined" &&
                                        <div style={{ paddingLeft: "14px" }}>  {ui('notes')}:
                                            <span style={{ fontSize: "13px", marginTop: "-12px", width: "100%" }}>{mainItem.spellInstruction}</span>
                                        </div>
                                    }

                                    {extraItems.length !== 0 && <li style={{ borderBottom: "1px solid #e6e6e6" }}></li>}
                                </React.Fragment>
                            ))}
                        </ul>
                    </div>
                    <div className="zdy_card2">
                        <ul>
                            {promotionEnabled && promotionDiscount > 0 && (
                                <li style={{ color: 'rgb(252 158 86)' }}>
                                    <span style={{ fontWeight: '600' }}>{promotionTitle}</span>
                                    <span style={{ fontWeight: '600' }}>{showPriceInCustomerMenu ? `-$${promotionDiscount.toFixed(2)}` : '\u00A0'}</span>
                                </li>
                            )}
                            {serviceType === 1 && Number(crmPointQuote?.redeemAmountCents || 0) > 0 && (
                                <li style={{ color: '#2e7d32' }}>
                                    <span>Points redeemed ({crmPointQuote.redeemPoints})</span>
                                    <span>-${(crmPointQuote.redeemAmountCents / 100).toFixed(2)}</span>
                                </li>
                            )}
                            {surcharges > 0 &&
                                <li>
                                    <span>{surchargeDescription}</span>
                                    <span>{showPriceInCustomerMenu ? `$${getDisplayedSurchargeAmount().toFixed(2)}` : '\u00A0'}</span>
                                </li>}
                            {getDeliveryFee() > 0 &&
                                <li>
                                    <span>{ui('deliveryFee')}</span>
                                    <span>{showPriceInCustomerMenu ? `$${getDeliveryFee().toFixed(2)}` : '\u00A0'}</span>
                                </li>}
                            {serviceType === 0
                                && crmMember
                                && Number(crmMember.rewardEnabled) === 1
                                && Number(crmMember.currentPoints || 0) > 0 && (
                                <li className="crm-pay-later-redemption">
                                    <span>{ui('redeemPoints')}</span>
                                    <span>{ui('redeemAtFinalPayment')}</span>
                                </li>
                            )}
                            <li>
                                <span style={{ fontWeight: 'bold' }}>{showPriceInCustomerMenu ? ui('total') : `Total Items: ${totalQuantity}`}</span>
                                <b>{showPriceInCustomerMenu ? `$${serviceType === 1 ? getPayableOrderAmount() : getFinalOrderAmount()}` : '\u00A0'}</b>
                            </li>
                        </ul>
                    </div>

                    {!showNoteBox ? (
                        <div className='zdy_card2'>
                            <div className='cell'>
                                <div
                                    className="cell2"
                                    onClick={() => setShowNoteBox(true)}
                                    style={{
                                        backgroundColor: 'rgb(236, 236, 236)',
                                        borderRadius: '4px',
                                        padding: '10px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}
                                >
                                    <span style={{ fontSize: '14px', fontWeight: 'bold' }}>{ui('notes')}</span>
                                    <img src="/img/plus-black-bold.svg" alt="Add" style={{ width: '14px', height: '14px', opacity: '0.6' }} />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <textarea
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            placeholder={ui('addNote')}
                            style={{
                                width: '100%',
                                padding: '10px',
                                marginTop: '10px',
                                borderRadius: '4px',
                                border: '1px solid #ddd',
                                fontSize: '14px',
                                resize: 'none',
                                boxSizing: 'border-box',
                                height: '80px',

                            }}
                            maxLength="100"
                        />
                    )}
          
                </div>
           

                {PaymentGateway === 'Tyro' && (
                    <div className='tyro-payment-refund-link' style={{ textAlign: 'center', marginTop: '10px', display: 'flex', alignItems: 'center', marginLeft:'17px',color:'#a29c9c' }}>
                        <div className='tyro-payment-refund-link-icon' style={{ marginRight: '10px' }}>
                        <span class="material-symbols-outlined">
                            policy
                        </span>
                        </div>

                        <div className='tyro-payment-refund-link-content'>
                        <a onClick={() => setIsRefundPolicyModalVisible(true)} style={{cursor:'pointer', textDecoration:'underline'}}>
                                Refund Policy for Online Orders
                            </a>
                        </div>
                    </div>
                )}


                <div style={{ height: '70px' }}></div>
                <div className="fixed-bottom bg-white" style={{ padding: '8px 16px',zIndex:'999' }}>
                    {
                        serviceType === 1 ? (
                            <button
                                type="button"
                                className="btn btn-block crm-order-action"
                                style={{zIndex: 500}}
                                disabled={isOrdering || !cartReady}
                                onClick={() => handlePayment(getPayableOrderAmount())}
                            >
                                {ui('toPay')}
                            </button>
                        ) : serviceType === 0 ? (
                            <button
                                type="button"
                                className="btn btn-block crm-order-action"
                                disabled={isOrdering || !cartReady}
                                onClick={() => saveOrder(getFinalOrderAmount())}
                            >
                                {ui('placeOrder')}
                            </button>
                        ) : null
                    }

                </div>

                <div className={`side_popup ${side_popup ? 'show' : ''}`}>
                    <div className="bg"></div>
                    <div className="popup_box">
                        <img src="/img/icon3.svg" className="close" id="btn4" onClick={toggleSidePopup} />
                        <div className="side_popup_t1">
                            {storeId && <img crossOrigin="anonymous" src={`${process.env.REACT_APP_SERVER_URL}/storeIcon/${storeId}`} onError={(e) => { e.target.onerror = null; e.target.src = '/img/default_top_icon.png'; }} />}
                        </div>
                        <div className="side_popup_t2">{storeName}</div>
                        <div className="side_popup_t3">
                            <p className="text1">{ui('openingHours')}</p>
                            <div>
                                {getStoreTimetable() && Object.entries(getStoreTimetable()).map(([day, hours]) =>
                                    <p key={day} className="text2">
                                        {day}: <span className='text3'>{
                                            (hours.start && hours.end)
                                                ? `${hours.start} - ${hours.end}`
                                                : "Closed"
                                        }
                                            {hours.breakStart && hours.breakEnd && ` (Break: ${hours.breakStart} - ${hours.breakEnd})`}
                                        </span>
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="side_popup_t3">
                            {/* <p className="text1">Contact Number:</p> */}
                            <p className="text2"> <img src="/img/icon4.svg" /> {storePhone}</p>
                            <p className="text2"> <img src="/img/icon5.svg" /> {storeAddress}</p>
                        </div>
                        <div className="footer">
                            <div className="r1">
                                Powered by <img src="/img/ipos_logo.png" />
                            </div>
                            {/* <div className="r2">
                                Beautiful menus for QR code table ordering, pickup delivery and payments.
                            </div> */}
                            <div className="r3">
                                <a href="https://www.i-pos.com.au/">{ui('learnMore')}</a>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    title={ui('memberLogin')}
                    wrapClassName="order-details-modal"
                    open={crmAuthVisible}
                    onCancel={() => setCrmAuthVisible(false)}
                    footer={null}
                    destroyOnClose={false}
                >
                    <div className="crm-auth-modal">
                        <div className="crm-auth-modal__modes">
                            <Button className={crmAuthMode === 'password' ? 'is-active' : ''} onClick={() => setCrmAuthMode('password')}>{ui('passwordLogin')}</Button>
                            <Button className={crmAuthMode === 'code' ? 'is-active' : ''} onClick={() => setCrmAuthMode('code')}>{ui('smsCodeLogin')}</Button>
                            <Button className={crmAuthMode === 'register' ? 'is-active' : ''} onClick={() => setCrmAuthMode('register')}>{ui('register')}</Button>
                        </div>

                        {crmAuthMode === 'register' && (
                            <>
                                <Input placeholder={ui('firstName')} value={crmAuthForm.firstName} onChange={(e) => setCrmAuthForm({ ...crmAuthForm, firstName: e.target.value })} />
                                <Input placeholder={ui('middleNameOptional')} value={crmAuthForm.middleName} onChange={(e) => setCrmAuthForm({ ...crmAuthForm, middleName: e.target.value })} />
                                <Input placeholder={ui('lastName')} value={crmAuthForm.lastName} onChange={(e) => setCrmAuthForm({ ...crmAuthForm, lastName: e.target.value })} />
                                <Input
                                    placeholder={crmEmailRequired ? ui('emailRequired') : ui('emailOptional')}
                                    type="email"
                                    value={crmAuthForm.email}
                                    onChange={(e) => setCrmAuthForm({ ...crmAuthForm, email: e.target.value })}
                                />
                                <Input aria-label={ui('birthday')} type="date" value={crmAuthForm.birthday} onChange={(e) => setCrmAuthForm({ ...crmAuthForm, birthday: e.target.value })} />
                                <select
                                    className="crm-auth-modal__select"
                                    aria-label={ui('selectAgeGroup')}
                                    value={crmAuthForm.ageGroup}
                                    onChange={(e) => setCrmAuthForm({ ...crmAuthForm, ageGroup: e.target.value })}
                                >
                                    <option value="">{ui('selectAgeGroup')}</option>
                                    <option value="under-18">{ui('under18')}</option>
                                    <option value="18-25">18–25</option>
                                    <option value="26-35">26–35</option>
                                    <option value="36-45">36–45</option>
                                    <option value="46-55">46–55</option>
                                    <option value="56-65">56–65</option>
                                    <option value="65+">{ui('age65Plus')}</option>
                                </select>
                            </>
                        )}

                        <Input
                            placeholder={ui('australianMobile')}
                            inputMode="tel"
                            maxLength={10}
                            value={crmAuthForm.phone}
                            onChange={(e) => setCrmAuthForm({ ...crmAuthForm, phone: e.target.value })}
                        />

                        {(crmAuthMode === 'code' || crmAuthMode === 'register') && (
                            <div className="crm-auth-modal__code">
                                <Input
                                    placeholder={ui('verificationCode')}
                                    inputMode="numeric"
                                    maxLength={6}
                                    value={crmAuthForm.code}
                                    onChange={(e) => setCrmAuthForm({ ...crmAuthForm, code: e.target.value.replace(/\D/g, '').slice(0, 6) })}
                                />
                                <Button className="crm-auth-modal__send-code" loading={crmSmsLoading} disabled={crmSmsCountdown > 0} onClick={sendCrmCode}>
                                    {crmSmsCountdown > 0 ? `${crmSmsCountdown}s` : ui('getCode')}
                                </Button>
                            </div>
                        )}

                        {(crmAuthMode === 'password' || crmAuthMode === 'register') && (
                            <Input.Password
                                placeholder={ui('passwordPlaceholder')}
                                value={crmAuthForm.password}
                                onChange={(e) => setCrmAuthForm({ ...crmAuthForm, password: e.target.value })}
                            />
                        )}

                        {crmAuthMode === 'register' && (
                            <Input.Password
                                placeholder={ui('confirmPassword')}
                                value={crmAuthForm.confirmPassword}
                                onChange={(e) => setCrmAuthForm({ ...crmAuthForm, confirmPassword: e.target.value })}
                            />
                        )}

                        {crmAuthMode === 'register' && (
                            <div className="crm-member-card__agreement crm-auth-modal__agreement">
                                <input
                                    id="crm-modal-legal-agreement"
                                    type="checkbox"
                                    checked={crmTermsAccepted}
                                    onChange={(e) => setCrmTermsAccepted(e.target.checked)}
                                />
                                <label htmlFor="crm-modal-legal-agreement">{ui('agreementPrefix')}</label>
                                <button type="button" onClick={() => setCrmLegalDocument('terms')}>{ui('termsOfUse')}</button>
                                <span>{uiLanguage === 'en' ? 'and' : '·'}</span>
                                <button type="button" onClick={() => setCrmLegalDocument('privacy')}>{ui('privacyPolicy')}</button>
                                <span>.</span>
                            </div>
                        )}

                        <Button className="crm-auth-modal__submit" block loading={crmAuthLoading} onClick={submitCrmAuth}>
                            {crmAuthMode === 'register' ? ui('createAccount') : ui('login')}
                        </Button>
                    </div>
                </Modal>

                <Modal
                    title={ui('completeDetailsTitle')}
                    wrapClassName="order-details-modal crm-profile-completion-modal"
                    open={crmProfileCompletionVisible}
                    onCancel={() => {
                        setCrmProfileCompletionVisible(false);
                        setCrmRegistrationToken('');
                    }}
                    footer={null}
                    width={420}
                    destroyOnClose={false}
                >
                    <div className="crm-profile-completion">
                        <p className="crm-profile-completion__help">{ui('completeDetailsHelp')}</p>
                        <label>
                            <span>{ui('firstName')} *</span>
                            <Input maxLength={15} value={crmAuthForm.firstName} onChange={(e) => setCrmAuthForm({ ...crmAuthForm, firstName: e.target.value })} />
                        </label>
                        <label>
                            <span>{ui('middleName')}</span>
                            <Input maxLength={15} value={crmAuthForm.middleName} onChange={(e) => setCrmAuthForm({ ...crmAuthForm, middleName: e.target.value })} />
                        </label>
                        <label>
                            <span>{ui('lastName')} *</span>
                            <Input maxLength={65} value={crmAuthForm.lastName} onChange={(e) => setCrmAuthForm({ ...crmAuthForm, lastName: e.target.value })} />
                        </label>
                        <label>
                            <span>{ui('email')}</span>
                            <Input type="email" maxLength={30} value={crmAuthForm.email} onChange={(e) => setCrmAuthForm({ ...crmAuthForm, email: e.target.value })} />
                        </label>
                        <label>
                            <span>{ui('birthday')}</span>
                            <Input type="date" value={crmAuthForm.birthday} onChange={(e) => setCrmAuthForm({ ...crmAuthForm, birthday: e.target.value })} />
                        </label>
                        <Button className="crm-auth-modal__submit" block loading={crmAuthLoading} onClick={submitCrmProfileCompletion}>
                            {ui('completeRegistration')}
                        </Button>
                    </div>
                </Modal>

                <CrmLegalModal
                    documentType={crmLegalDocument}
                    open={Boolean(crmLegalDocument)}
                    onClose={() => setCrmLegalDocument(null)}
                    language={uiLanguage}
                    storeName={storeName}
                    storePhone={storePhone}
                    storeAddress={storeAddress}
                />

                {/* 用户信息输入弹出框 */}
                <Modal
                    title={ui('enterYourInformation')}
                    wrapClassName="order-details-modal"
                    visible={isUserInfoModalVisible}
                    onOk={handleUserInfoOk}
                    onCancel={handleUserInfoCancel}
                    style={{ position: 'fixed', bottom: 0,  padding: 0, width: '100%', left: 0,right: 0 }}
                    okButtonProps={{
                        
                        style: { backgroundColor:styleColor, borderColor:styleColor, color: '#715700' }, // 自定义按钮样式
                      }}
             
                >
                    <div className="customer-info-modal-form">
                        <label>
                            <span className="customer-info-modal-icon material-symbols-outlined">person</span>
                            <Input
                                placeholder={ui('name')}
                                value={userInfo.name}
                                onChange={(e) => setUserInfo({ ...userInfo, name: e.target.value })}
                            />
                        </label>
                        <label>
                            <span className="customer-info-modal-icon material-symbols-outlined">call</span>
                            <Input
                                placeholder={ui('contactNumber')}
                                value={userInfo.contactNumber}
                                onChange={(e) => setUserInfo({ ...userInfo, contactNumber: e.target.value })}
                            />
                        </label>
                    {(orderServiceMode === 'Delivery' || userInfo.address) && (
                        <label>
                            <span className="customer-info-modal-icon material-symbols-outlined">location_on</span>
                            <Input
                                id="delivery-address-input"
                                ref={deliveryAddressInputRef}
                                placeholder={ui('address')}
                                value={userInfo.address}
                                onChange={(e) => {
                                    setUserInfo({ ...userInfo, address: e.target.value });
                                    setDeliveryAddressPlaceId('');
                                    setDeliveryQuote(null);
                                    setDeliveryQuoteError(e.target.value ? ui('pleaseSelectDeliveryAddress') : '');
                                }}
                                onBlur={() => {
                                    if (orderServiceMode === 'Delivery' && userInfo.address && !deliveryAddressPlaceId) {
                                        setDeliveryQuoteError(ui('pleaseSelectDeliveryAddress'));
                                    }
                                }}
                            />
                            {orderServiceMode === 'Delivery' && (
                                <div className="customer-info-modal-fee">
                                    {deliveryQuoteLoading && ui('calculatingDelivery')}
                                    {!deliveryQuoteLoading && deliveryQuoteError && deliveryQuoteError}
                                    {!deliveryQuoteLoading && !deliveryQuoteError && deliveryQuote && `${ui('estimatedDeliveryFee')}: $${Number(deliveryQuote.deliveryFee).toFixed(2)}`}
                                </div>
                            )}
                        </label>
                    )}
                    </div>
                </Modal>

                {/* 取餐时间选择弹出框 */}
                <Modal
                    title={ui('schedule')}
                    wrapClassName="order-details-modal"
                    visible={isScheduleModalVisible}
                    onOk={handleScheduleOk}
                    onCancel={handleScheduleCancel}
                    okButtonProps={{ style: { backgroundColor: styleColor, borderColor: styleColor, color: '#715700' } }}
                    
                >
                    <div style={{ marginBottom: '10px' }}>
                        <label>
                            <input
                                type="radio"
                                checked={scheduleInfo.asap}
                                onChange={() => setScheduleInfo({ ...scheduleInfo, asap: true, time: null })}
                            />
                            {ui('asap')}
                        </label>
                    </div>
                    <div>
                        <label>
                            <input
                                type="radio"
                                checked={!scheduleInfo.asap}
                                onChange={() => setScheduleInfo({ ...scheduleInfo, asap: false })}
                            />
                            {ui('pickUpTime')}
                        </label>
                        {!scheduleInfo.asap && (
                            <TimePicker
    popupClassName="order-details-time-picker"
    value={scheduleInfo.time}
    onChange={(time) => setScheduleInfo({ ...scheduleInfo, time })}
    format="HH:mm"
    minuteStep={15}
    style={{ marginLeft: '10px' }}
    disabledHours={() => {
        const hours = [];
        const schedule = getCurrentDaySchedule();
        const now = moment();
        const currentHour = now.hour();

        if (!schedule || !schedule.start || !schedule.end) {
            // 如果今天店铺关闭，禁用所有小时
            return Array.from({ length: 24 }, (_, i) => i);
        }

        const openingHour = parseInt(schedule.start.split(':')[0], 10);
        const closingHour = parseInt(schedule.end.split(':')[0], 10);
        const breakStartHour = schedule.breakStart ? parseInt(schedule.breakStart.split(':')[0], 10) : null;
        const breakEndHour = schedule.breakEnd ? parseInt(schedule.breakEnd.split(':')[0], 10) : null;

        for (let i = 0; i < 24; i++) {
            // 禁用早于开店时间或晚于关店时间的小时
            if (i < openingHour || i >= closingHour) {
                hours.push(i);
            }
            // 禁用午休时间
            else if (breakStartHour !== null && breakEndHour !== null && i >= breakStartHour && i < breakEndHour) {
                hours.push(i);
            }
            // 禁用当前小时之前的小时
            else if (i < currentHour) {
                hours.push(i);
            }
        }

        return hours;
    }}
    disabledMinutes={(selectedHour) => {
        const minutes = [];
        const schedule = getCurrentDaySchedule();
        const now = moment();
        const currentHour = now.hour();
        const currentMinute = now.minute();

        if (!schedule || !schedule.start || !schedule.end) {
            // 如果今天店铺关闭，禁用所有分钟
            return Array.from({ length: 60 }, (_, i) => i);
        }

        const openingTime = schedule.start.split(':').map(Number);
        const closingTime = schedule.end.split(':').map(Number);
        const breakStartTime = schedule.breakStart ? schedule.breakStart.split(':').map(Number) : null;
        const breakEndTime = schedule.breakEnd ? schedule.breakEnd.split(':').map(Number) : null;

        // 禁用开店前的分钟
        if (selectedHour === openingTime[0] && selectedHour === currentHour) {
            for (let i = 0; i < Math.max(openingTime[1], currentMinute); i++) {
                minutes.push(i);
            }
        }

        // 禁用关店后的分钟
        if (selectedHour === closingTime[0]) {
            for (let i = closingTime[1]; i < 60; i++) {
                minutes.push(i);
            }
        }

        // 禁用午休时间的分钟
        if (breakStartTime && breakEndTime) {
            if (selectedHour > breakStartTime[0] && selectedHour < breakEndTime[0]) {
                // 整个小时都在午休时间
                for (let i = 0; i < 60; i++) {
                    minutes.push(i);
                }
            } else if (selectedHour === breakStartTime[0]) {
                for (let i = breakStartTime[1]; i < 60; i++) {
                    minutes.push(i);
                }
            } else if (selectedHour === breakEndTime[0]) {
                for (let i = 0; i < breakEndTime[1]; i++) {
                    minutes.push(i);
                }
            }
        }

        // 禁用当前小时之前的分钟
        if (selectedHour === currentHour) {
            for (let i = 0; i < currentMinute; i++) {
                minutes.push(i);
            }
        }

        return minutes;
    }}
    hideDisabledOptions
/>

                        

                        )}
                    </div>
                </Modal>
            </>)}

            {isRefundPolicyModalVisible && (
                    <div 
                        className="refund-policy-modal-overlay" 
                        onClick={() => setIsRefundPolicyModalVisible(false)}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 1000
                        }}
                    >
                        <div 
                            className="refund-policy-modal" 
                            onClick={(e) => e.stopPropagation()} 
                            style={{
                                background: '#fff',
                                borderRadius: '8px',
                                padding: '20px',
                                maxWidth: '500px',
                                width: '90%',
                                position: 'relative'
                            }}
                        >
                            <span 
                                className="material-symbols-outlined" 
                                onClick={() => setIsRefundPolicyModalVisible(false)}
                                style={{
                                    position: 'absolute',
                                    top: '10px',
                                    right: '10px',
                                    cursor: 'pointer',
                                    fontSize: '24px'
                                }}
                            >
                                close
                            </span>
                            <h2 style={{marginBottom:'15px',fontSize:'19px'}}>Refund Policy</h2>
                            <p style={{fontSize:'14px', lineHeight:'1.5',padding:'12px'}}>
                                Refunds are reviewed case-by-case for issues like incorrect or missing items, or severe quality problems. 
                                Contact us within 24 hours with proof to resolve concerns.
                                Non-refundable: change of mind or third-party delivery delays.
                            </p>
                        </div>
                    </div>
                )}

             {/* Tyro Payment Modal */}
      <Modal
        title="Complete Payment"
        wrapClassName="order-details-modal"
        open={isTyroModalVisible}
        footer={null}
        onCancel={async () => {
          // 用户手动关闭 Modal 时取消订单
          if (tyroOrderId) {
            await cancelTyroOrder(tyroOrderId);
          }
          
          setIsTyroModalVisible(false);
          setPaySecret(null);
          setTyroOrderId(null);
          setIsOrdering(false); // Reset ordering state when modal is closed
        }}
        width={600}
      >
        {paySecret && (
          <TyroPayment
            paySecret={paySecret}
            orderAmount={tyroOrderAmount}
            onPaymentSuccess={handlePaymentSuccess}
            onPaymentError={handlePaymentError}
          />
        )}
      </Modal>
        </div>
    );
}

export default OrderDetails;
